import {
  Alert,
  Autocomplete,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import {
  GenerateCarrierEProSeries,
  GetCarrierEProSeries,
  GetCarrierProSeriesStatus,
  GetCarriers,
  ImportCarrierEProSeries,
  UpdateCarrier,
  UpdateCarrierClaimSettings,
  UpdateCarrierDetails,
  UpdateCarrierInvoiceAuditThreshold,
  UpdateCarrierProSeries,
  UpdateCarrierRateQuoteSettings,
  UpdateCarrierSurcharge,
  UpdateCarrierThirdPartyInfo
} from '../../apis/Agency';
import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import ClearIcon from '@mui/icons-material/Clear';
import SortIcon from '@mui/icons-material/Sort';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CreateCarrier from './CreateCarrier';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import './Carriers.css';
import { GetCarrierDetails } from '../../apis/Agency';
import { ErrorToast, successToast } from '../../components/Toasts';
import { ToastContainer, useToast } from 'react-toastify';
import SettingsIcon from '@mui/icons-material/Settings';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import {
  MaterialReactTable,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { GarageOutlined, TroubleshootOutlined } from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import NoLogo from '../../assets/carrier logos/No Logo.png';
import { multiSectionDigitalClockClasses } from '@mui/x-date-pickers';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { MetaTags } from 'react-meta-tags';
import { base_logo_url, base_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import { Col, Row } from 'reactstrap';
import { formatPhoneNumber } from '../../apis/Utils';
import NumbersIcon from '@mui/icons-material/Numbers';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
function Carriers(props) {
  const [proNumberSuffixPosition, setProNumbersuffixPosition] = useState('Pre');
  const [surchargeType, setSurchargeType] = useState('%');
  const [paymentTerms, setPaymentTerms] = useState('Inbound');
  const [LTLServiceType, setLTLServiceType] = useState('All');
  const [parcelServiceType, setParcelServiceType] = useState('All');
  const [secondParcelServiceType, setSecondParcelServiceType] = useState('All');
  const [secondLTLServiceType, setSecondLTLServiceType] = useState('All');
  const [ratesType, setRatesType] = useState('All');
  const [guaranteedType, setGuaranteedType] = useState('All');
  const [secondPaymentTerms, setSecondPaymentTerms] = useState('Inbound');
  const [secondRatesType, setSecondRatesType] = useState('All');
  const [secondGuaranteedType, setSecondGuaranteedType] = useState('All');
  const [surchargeValue, setSurchargeValue] = useState('');
  const [thresholdValue, setThresholdValue] = useState('');
  const [thresholdType, setThresholdType] = useState('$');
  const [proNumberSuffixValue, setProNumberSuffixValue] = useState('');
  const [proNumberFrom, setProNumberFrom] = useState('');
  const [proNumberTo, setProNumberTo] = useState('');
  const [proNumberAlert, setProNumberAlert] = useState('');
  const [proNumberLeft, setProNumberLeft] = useState('');
  const [proNumberTotals, setProNumberTotals] = useState('');
  const [pronmbsApiData, setPronmbsApiData] = useState(null);
  const surchargeTypeArr = ['All', 'Inbound', 'Outbound', 'Third Party'];
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleChangeProNmb = event => {
    setProNumbersuffixPosition(event.target.value);
  };
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const history = useHistory();
  const [carriersLoader, setCarriersLoader] = useState(true);
  const [carriers, setCarriers] = useState([]);
  const [carrierProSeriesStatus, setCarrierProSeriesStatus] = useState([]);
  const [TLcarriers, setTLCarriers] = useState([]);
  const [LTLCarriers, setLTLCarriers] = useState([]);
  const [parcelCarriers, setParcelCarriers] = useState([]);
  const [configuredCarrierName, setConfiguredCarrierName] = useState('');
  const [configuredCarrierID, setConfiguredCarrierID] = useState(0);

  const [configuredCarrierArray, setConfiguredCarrierArray] = useState([]);
  const [configuredCarrierLoader, setConfiguredCarrierLoader] = useState(false);
  const [validattionErrors, setValidattionErrors] = useState({});
  const [FinalConfigureCarrierArray, setFinalConfigureCarrierArray] =
    useState(null);
  const [carrierID, setCarrierID] = useState('');
  const [thirdPatyAccDetails, setThirdPatyAccDetails] = useState({
    id: 0,
    status: true,
    thirdPartyAccountNumber: '',
    companyName: '',
    streetLines: '',
    city: '',
    state: '',
    postalCode: '',
    countryCode: '',
    phoneNumber: '',
    emailAddress: ''
  });

  const disabledErpoCarriers = ['Estes', 'XPO', 'ODFL', 'Central Transport'];

  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [email, setEmail] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [isEProSeriesGenerate, setIsEProSeriesGenerate] = useState(null);
  const [carrierStatus, setCarrierStatus] = useState('');
  const [userPermissionsArr, setUserPermissionsArr] =
    useState(userRolePermissions);
  const [createUpdateCarrier, setCreateUpdateCarrier] = useState(false);
  const [carrierTabValue, setCarrierTabValue] = useState('1');

  useEffect(() => {
    if (!configuredCarrierName) return; // avoid running on empty

    setCarrierTabValue(!isEProSeriesGenerate ? '2' : '1');
  }, [isEProSeriesGenerate]);

  console.log(configuredCarrierName, 'configuredCarrierName');

  // useEffect(() => {
  //   setThirdPatyAccDetails({ ...thirdPatyAccDetails, id: carrierID });
  // }, [carrierID]);
  const isMobile = useIsMobile();

  const [claimSettingsObj, setClaimSettingsObj] = useState({
    carrierId: 0,
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    copyTo: ''
  });

  const [errors, setErrors] = useState({
    contactEmail: '',
    contactPhone: ''
  });

  const [isNewUI, setIsNewUI] = useState(false);
  const [listView, setListView] = useState(true);
  // const [selectedCarrier, setSelectedCarrier] = useState(null);
  const selectedCarrier = useRef(null);
  const handleToggle = event => {
    setIsNewUI(event.target.checked);
    selectedCarrier.current = null;
  };
  const [forceUpdateCounter, setForceUpdateCounter] = useState(0);

  const forceUpdate = () => {
    setForceUpdateCounter(prev => prev + 1);
  };
  const handleClaimSettingsChange = (field, value) => {
    setClaimSettingsObj(prev => ({ ...prev, [field]: value }));

    // validation

    if (field === 'contactEmail') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setErrors(prev => ({
        ...prev,
        contactEmail: emailRegex.test(value) ? '' : 'Enter a valid email'
      }));
    }

    if (field === 'contactPhone') {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length !== 10) {
        setErrors(prev => ({
          ...prev,
          contactPhone: 'Phone number must be 10 digits'
        }));
      } else {
        setErrors(prev => ({
          ...prev,
          contactPhone: ''
        }));
      }
    }
  };
  // const [selectedTab, setSelectedTab] = useState('1');
  const selectedTab = useRef('1');
  const [activeCarriers, setActiveCarriers] = useState([]);

  useEffect(() => {
    if (UserIsAdmin) {
      // Admins can see everything directly
      const allCarriers = [
        { permissionName: 'LTL Carriers', value: '1' },
        { permissionName: 'TL Carriers', value: '2' },
        { permissionName: 'Parcel Carriers', value: '3' }
      ];

      setUserPermissionsArr(allCarriers);
      setActiveCarriers(allCarriers);
      setColumnsData(mncolumns);
      return;
    }

    if (userRolePermissions?.length && !UserIsAdmin) {
      // Complete list of all possible carriers
      const allPossibleCarriers = [
        { permissionName: 'LTL Carriers', value: '1' },
        { permissionName: 'TL Carriers', value: '2' },
        { permissionName: 'Parcel Carriers', value: '3' }
      ];

      // Filter for carrier permissions from user's permissions
      const filteredCarrierPermissions = userRolePermissions.filter(item =>
        item.permissionName?.includes('Carriers')
      );

      setUserPermissionsArr(filteredCarrierPermissions);

      if (createUpdateCarrier) {
        setColumnsData(mncolumns);
      }

      // Create a map of assigned permissions for easy lookup
      const assignedPermissionsMap = new Map();
      filteredCarrierPermissions.forEach(perm => {
        assignedPermissionsMap.set(perm.permissionName, perm);
      });

      // Check which carriers are assigned vs not assigned
      const carrierStatus = allPossibleCarriers.map(carrier => {
        const assignedPerm = assignedPermissionsMap.get(carrier.permissionName);
        const isAssigned = !!assignedPerm;

        return {
          ...carrier,
          isAssigned: isAssigned,
          // If assigned, include the permission details
          ...(assignedPerm && {
            status: assignedPerm.status,
            levels: Object.keys(assignedPerm)
              .filter(key => key.startsWith('level'))
              .reduce((acc, key) => {
                acc[key] = assignedPerm[key];
                return acc;
              }, {})
          })
        };
      });

      // Filter for active carriers (assigned AND active)
      const mappedActive = filteredCarrierPermissions
        .filter(c => {
          const hasAnyLevelTrue = Object.keys(c).some(
            key => key.startsWith('level') && c[key] === true
          );
          return c.status === true || hasAnyLevelTrue;
        })
        .map(c => ({
          ...c,
          value:
            c.value ||
            (c.permissionName.includes('LTL Carriers')
              ? '1'
              : c.permissionName.includes('TL Carriers')
                ? '2'
                : c.permissionName.includes('Parcel Carriers')
                  ? '3'
                  : '')
        }));

      setActiveCarriers(mappedActive);

      if (mappedActive.length > 0 && !selectedTab.current) {
        selectedTab.current = mappedActive[0].value;
      }

      // Optional: You could also set a state for unassigned carriers
      const unassignedCarriers = allPossibleCarriers.filter(
        carrier => !assignedPermissionsMap.has(carrier.permissionName)
      );
      console.log('carrierStatus:', carrierStatus);
    }
  }, [UserIsAdmin, userRolePermissions, createUpdateCarrier]);
  console.log(carriers, 'carriers', selectedTab);

  const handleSuccessCarriersStateFlow = (ApiRes, type, action) => {
    // if (isNewUI) {
    //   selectedTab.current = 1;
    // }
    const CarrierArray = ApiRes?.data?.data;
    setCarriersLoader(false);

    const LTL = CarrierArray.filter(items => items.cType === 'LTL').sort(
      (a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    const TL = CarrierArray.filter(items => items.cType === 'TL').sort((a, b) =>
      (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    const Parcels = CarrierArray.filter(items => items.cType === 'Parcel').sort(
      (a, b) =>
        (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase())
    );

    setLTLCarriers(LTL);
    setTLCarriers(TL);
    setParcelCarriers(Parcels);

    // Handle special cases first
    if (!isNewUI) {
      if (props?.location?.state === 'Non-LTL' && !action) {
        setCarriers(TL);
        selectedTab.current = 2;
        return;
      }

      // if (action) {
      //   return;
      // }

      const hasPermission = permissionName => {
        const carrierData = userRolePermissions.find(
          item => item.permissionName === permissionName
        );
        if (!carrierData) return false;
        return Object.entries(carrierData).some(
          ([key, value]) =>
            (key.toLowerCase().includes('level') ||
              key.toLowerCase().includes('status')) &&
            value === true
        );
      };
      if (UserIsAdmin && !action) {
        setCarriers(LTL);
        selectedTab.current = 1;
      } else if (type === 'LTL' && hasPermission('LTL Carriers')) {
        setCarriers(LTL);
        selectedTab.current = 1;
      } else if (!UserIsAdmin) {
        const getAvailableCarrierType = () => {
          if (hasPermission('LTL Carriers')) return { carriers: LTL, tab: '1' };
          if (hasPermission('TL Carriers')) return { carriers: TL, tab: '2' };
          if (hasPermission('Parcel Carriers'))
            return { carriers: Parcels, tab: '3' };
          return { carriers: [], tab: null };
        };

        switch (selectedTab.current) {
          case '1':
            if (hasPermission('LTL Carriers')) {
              setCarriers(LTL);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          case '2':
            if (hasPermission('TL Carriers')) {
              setCarriers(TL);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          case '3':
            if (hasPermission('Parcel Carriers')) {
              setCarriers(Parcels);
            } else {
              const available = getAvailableCarrierType();
              setCarriers(available.carriers);
              if (available.tab) selectedTab.current = available.tab;
            }
            break;

          default:
            const available = getAvailableCarrierType();
            setCarriers(available.carriers);
            if (available.tab) selectedTab.current = available.tab;
        }
      }
    }
  };
  const fetchCarriers = () => {
    GetCarriers(AgencyID)
      .then(res => res.status === 200 && handleSuccessCarriersStateFlow(res))
      .catch(err => console.log(err, 'err'));
  };
  console.log(selectedTab, 'selectedTab222');
  useEffect(() => {
    fetchCarriers();

    GetCarrierProSeriesStatus(AgencyID)
      .then(res => {
        setCarrierProSeriesStatus(res?.data?.data);
      })
      .catch(err => console.log(err, 'err'));
  }, []);

  const [open, setOpen] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialogImport, setOpenConfirmDialogImport] = useState(false);
  const [openEProDialog, setOpenEProDialog] = useState(false);
  const [openEProDialogGenerate, setOpenEProDialogGenerate] = useState(false);
  const [proNumberErrors, setProNumbersErrors] = useState({});
  const [proNmbChanged, setProNmbChanged] = useState(false);

  const [eproSeriesData, setEproSeriesData] = useState([]);
  const [eproSeriesDataGenerate, setEproSeriesDataGenerate] = useState([]);
  const [eProSeriesGenerateError, setEProSeriesGenerateError] = useState('');

  const [loadingEproSeries, setLoadingEproSeries] = useState(false);
  const [loadingEproSeriesGenerate, setLoadingEproSeriesGenerate] =
    useState(false);

  const handleGenerateEProSeriesDialog = () => {
    if (configuredCarrierID === 10 && !proNumberSuffixValue) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberSuffixValue: 'Please enter suffix value'
      });
      return;
    }
    if (!proNumberFrom) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Please enter starting pro-number'
      });
      return;
    }
    if (!proNumberTo) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Please enter ending pro-number'
      });
      return;
    }
    if (
      [18, 5, 255, 16].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 8
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 8 digits'
      });
      return;
    }
    if (
      [18, 5, 255, 16].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 8
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 8 digits'
      });
      return;
    }
    if (
      [17].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 10
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 10 digits'
      });
      return;
    }
    if (
      [17].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 10
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 10 digits'
      });
      return;
    }
    if (
      [2].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 9
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 9 digits'
      });
      return;
    }
    if (
      [2].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 9
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 9 digits'
      });
      return;
    }
    if (
      [10].includes(configuredCarrierID) &&
      proNumberFrom.toString().length !== 7
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: 'Starting pro-number must be equal to 7 digits'
      });
      return;
    }
    if (
      [10].includes(configuredCarrierID) &&
      proNumberTo.toString().length !== 7
    ) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'Ending pro-number must be equal to 7 digits'
      });
      return;
    }
    if (parseInt(proNumberFrom) > 2147483647) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom:
          'Starting pro-number exceeds the limit of maximum number: 2147483647'
      });
      return;
    }
    if (parseInt(proNumberTo) > 2147483647) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo:
          'Ending pro-number exceeds the limit of maximum number: 2147483647'
      });
      return;
    }
    if (
      proNumberFrom &&
      proNumberTo &&
      parseInt(proNumberTo) < parseInt(proNumberFrom)
    ) {
      // setProNumberTo('');
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo:
          'Ending pro-number cannot be smaller than starting pro-number'
      });
      return;
    }

    setLoadingEproSeriesGenerate(true);
    setOpenEProDialogGenerate(true);

    const dataObj = {
      carrierId: configuredCarrierID,
      suffix: proNumberSuffixValue,
      startFrom: proNumberFrom,
      endTo: proNumberTo
    };
    GenerateCarrierEProSeries(dataObj)
      .then(res => {
        setEproSeriesDataGenerate(res?.data?.data);
        setLoadingEproSeriesGenerate(false);
      })
      .catch(err => {
        setEProSeriesGenerateError(err?.response?.data);
        setLoadingEproSeriesGenerate(false);
      });
  };

  const handleImportEProSeries = () => {
    const dataObj = eproSeriesDataGenerate.map(epronumber => ({
      carrierId: configuredCarrierID,
      locationId: 0,
      serialNumber: epronumber.serialNumber,
      draftProNumber: epronumber.draftProNumber,
      checkDigit: epronumber.checkDigit,
      finalProNumber: epronumber.finalProNumber
    }));

    ImportCarrierEProSeries(dataObj)
      .then(res => {
        handleCloseEProSeriesDialogGenerate();
        handleConfirmDialogCloseImport();
        if (isNewUI) {
          fetchCarriers();
          // handleTabChange(null, selectedTab.current);
        }
        // else {
        //   selectedCarrier.current = {};
        // }

        successToast('E-PRO series imported successfully');
      })
      .catch(err => {
        handleCloseEProSeriesDialogGenerate();
        handleConfirmDialogCloseImport();
        ErrorToast('E-PRO series import failed');
      });
  };
  const handleImportEProSeriesDialog = () => {
    setOpenConfirmDialogImport(true);
  };

  const handleOpenEProSeriesDialog = () => {
    setLoadingEproSeries(true);
    setOpenEProDialog(true);

    GetCarrierEProSeries(configuredCarrierID)
      .then(res => {
        setEproSeriesData(res?.data?.data);
        setLoadingEproSeries(false);
      })
      .catch(err => {
        setLoadingEproSeries(false);
      });
  };
  const handleCloseEProSeriesDialog = () => {
    setEproSeriesData([]);
    setOpenEProDialog(false);
  };
  const handleCloseEProSeriesDialogGenerate = () => {
    setEproSeriesDataGenerate([]);
    setEProSeriesGenerateError('');
    setOpenEProDialogGenerate(false);
  };

  const eproSeriesColumns = [
    {
      accessorKey: 'draftNumber',
      id: 'draft',
      header: 'PRO #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'checkDigit',
      id: 'checkDigit',
      header: 'Check Digit',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'finalNumber',
      id: 'final',
      header: 'Final PRO #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'bolNumber',
      id: 'bol',
      header: 'BOL #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'status',
      id: 'status',
      header: 'Status',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box>
              <Chip
                sx={
                  row.original.status.toLowerCase() === 'booked'
                    ? { color: '#1b5e20', backgroundColor: '#c8e6c9' }
                    : { color: '#448aff', backgroundColor: '#bbdefb' }
                }
                label={renderedCellValue}
              />
            </Box>
          )}
        </>
      )
    }
  ];

  const eproSeriesColumnsGenerate = [
    {
      accessorKey: 'serialNumber',
      id: 'serialno',
      header: 'Sr #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'draftProNumber',
      id: 'draftprono',
      header: 'PRO #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'checkDigit',
      id: 'checkDigit',
      header: 'Check Digit',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    },
    {
      accessorKey: 'finalProNumber',
      id: 'final',
      header: 'Final PRO #',
      size: 50,
      Cell: ({ renderedCellValue, row }) => (
        <>
          {renderedCellValue && (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>{renderedCellValue}</span>
            </Box>
          )}
        </>
      )
    }
  ];

  const handleConfirmationCarrierSettins = () => {
    let proNumberErrors = {};
    // if (!proNumberFrom) {
    //   proNumberErrors['proNumberFrom'] = 'Enter starting pro-number';
    //   setProNumbersErrors(proNumberErrors);
    // } else if (!proNumberTo) {
    //   proNumberErrors['proNumberTo'] = 'Enter ending pro-number';
    //   setProNumbersErrors(proNumberErrors);
    // }
    // else
    if (
      proNumberFrom &&
      proNumberTo &&
      parseInt(proNumberTo) < parseInt(proNumberFrom)
    ) {
      // setProNumberTo('');
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: 'ending pro-number cannot be less than starting pronumber'
      });
    } else if (proNumberFrom && proNumberTo && !proNumberAlert) {
      proNumberErrors['proNumberAlert'] = 'Enter minimum pro-number for Alert';
      setProNumbersErrors(proNumberErrors);
    } else setOpenConfirmDialog(true);
  };

  const handleConfirmDialogClose = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDialogCloseImport = () => {
    setOpenConfirmDialogImport(false);
  };
  const handleClose = () => {
    // setSecondPaymentTerms('Inbound');
    selectedCarrier.current = {};
    setValidationErrors({
      ...validationErrors,
      emailError: null
    });
    setErrors({});
    setClaimSettingsObj({
      carrierId: 0,
      contactEmail: '',
      contactName: '',
      contactPhone: '',
      copyTo: ''
    });
    setEmail('');
    setConfiguredCarrierArray([]);
    setOpen(false);
    setValidattionErrors({});
    setCarrierID('');
    setCarrierStatus('');
    setProNumbersuffixPosition('Prefix');
    setProNumberSuffixValue('');
    setProNumberFrom('');
    setProNumberTo('');
    setProNumberAlert('');
    setProNumberLeft('');
    setProNumberTotals('');
    setSurchargeType('%');
    setSurchargeValue('');
    setSelectedOptions([]);
    setThirdPatyAccDetails({
      id: 0,
      status: true,
      thirdPartyAccountNumber: '',
      companyName: '',
      streetLines: '',
      city: '',
      state: '',
      postalCode: '',
      countryCode: '',
      phoneNumber: '',
      emailAddress: ''
    });
    setConfiguredCarrierName('');
    setConfiguredCarrierID(0);
    setProNumbersErrors({});
    setThresholdType('$');
    setThresholdValue('');
  };

  const handleUpdateCarrier = (e, items) => {
    if (!isNewUI) {
      e.stopPropagation();
    }
    setListView(false);
    setPronmbsApiData(items);
    // const items = data.row.original;
    setOpen(true);
    setSurchargeType(items.surchargeType ? items.surchargeType : '%');
    setSelectedOptions(
      items.surchargeApplyOn ? items.surchargeApplyOn.split(',') : []
    );
    setIsEProSeriesGenerate(items.isEProSeriesGenerate);
    setSurchargeValue(items.surcharge ? items.surcharge : '');
    setCarrierID(items.id);
    setCarrierStatus(items.active);
    items.proNumberSuffixPosition &&
      setProNumbersuffixPosition(items.proNumberSuffixPosition);
    items.proNumberSuffix && setProNumberSuffixValue(items.proNumberSuffix);
    items.proNumberStart && setProNumberFrom(items.proNumberStart);
    items.proNumberEnd && setProNumberTo(items.proNumberEnd);
    items.proNumberAlertOn && setProNumberAlert(items.proNumberAlertOn);
    items.proNumberLeft
      ? setProNumberLeft(items.proNumberLeft)
      : setProNumberLeft(0);
    items.proNumberTotals && setProNumberTotals(items.proNumberTotals);
    items.proNumberAlertNotifyTo && setEmail(items.proNumberAlertNotifyTo);
    // setThirdPatyAccNmb(items.thirdPartyAccountNumber);
    setThirdPatyAccDetails({
      ...thirdPatyAccDetails,
      id: items.id ? items.id : 0,
      thirdPartyAccountNumber: items.thirdPartyAccountNumber
        ? items.thirdPartyAccountNumber
        : '',
      companyName: items.tpCompanyName ? items.tpCompanyName : '',
      streetLines: items.tpStreetLines ? items.tpStreetLines : '',
      city: items.tpCity ? items.tpCity : '',
      state: items.tpStateOrProvinceCode ? items.tpStateOrProvinceCode : '',
      postalCode: items.tpPostalCode ? items.tpPostalCode : '',
      countryCode: items.tpCountryCode ? items.tpCountryCode : '',
      phoneNumber: items.tpPhoneNumber ? items.tpPhoneNumber : '',
      emailAddress: items.tpEmail ? items.tpEmail : ''
    });

    items.name && setConfiguredCarrierName(items.name);
    setConfiguredCarrierID(items.carrierId);
    setClaimSettingsObj({
      carrierId: items.carrierId,
      contactEmail: items.claimContactEmail,
      contactName: items.claimContactPerson,
      contactPhone: items.claimContactPhone,
      copyTo: items.claimContactCC
    });

    setPaymentTerms(
      items.rqSettingType === 'Both' && items.rqSettingType2 === 'Both'
        ? 'Inbound'
        : items.rqSettingType
    );
    setRatesType(items.rqSettingTypeInfo);
    setGuaranteedType(items.rqSettingTypeFilter);
    setSecondPaymentTerms(items.rqSettingType2);
    setSecondRatesType(items.rqSettingTypeInfo2);
    setSecondGuaranteedType(items.rqSettingTypeFilter2);
    setThresholdValue(items.iaThreshold ? items.iaThreshold : '');
    setThresholdType(items.iaThresholdType ? items.iaThresholdType : '$');
  };

  const handleSuccessGetCarriers = action => {
    GetCarriers(AgencyID)
      .then(
        res =>
          res.status === 200 &&
          handleSuccessCarriersStateFlow(res, 'LTL', action)
      )
      .catch(err => console.log(err, 'err'));
  };
  const handleUpdateCarrierRequest = () => {
    let obj = {
      id: carrierID,
      // status: carrierStatus,
      // thirdPartyAccountNumber: thirdPatyAccNmb,
      proNumberSuffix: proNumberSuffixValue,
      proNumberSuffixPosition: proNumberSuffixPosition,
      proNumberStart: proNumberFrom ? proNumberFrom : 0,
      proNumberEnd: proNumberTo ? proNumberTo : 0,
      proNumberLeft:
        !proNmbChanged && proNumberLeft !== null
          ? proNumberLeft
          : handleRemainingPro(),
      proNumberAlertOn: proNumberAlert ? proNumberAlert : 0,
      proNumberAlertNotifyTo: email ? email : ''
    };
    UpdateCarrierProSeries(obj)
      .then(res => {
        successToast('Carrier Settings Updated!');
        setOpen(false);
        setOpenConfirmDialog(false);
        // if (isNewUI) {
        //   fetchCarriers();
        // }
        // else {
        //   handleClose();
        // }
        // selectedCarrier.current = {};
        handleSuccessGetCarriers('Updated');
      })
      .catch(err => {
        ErrorToast(err?.message);
        handleConfirmDialogClose();
        console.log(err, 'err');
      });
  };
  const calculateConsumed = (totals, left) => {
    const totalsNum = Number(totals);
    const leftNum = Number(left);
    return totalsNum - leftNum;
  };

  const mncolumns = [
    {
      accessorKey: 'logo',
      id: 'logo',
      header: 'Logo',
      size: 1,
      Cell: ({ cell, row }) => (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              minWidth: '100px',
              maxWidth: '100px',
              paddingLeft: '25px'
            }}
          >
            <AvatarGroup spacing='small'>
              <Avatar
                variant='circular'
                alt={cell.getValue()}
                src={base_logo_url + cell.getValue()}
                sx={{
                  width: { xs: 35, sm: 40 },
                  height: { xs: 35, sm: 40 },
                  mx: { xs: 3 },
                  // p: '2px',
                  background:
                    row.original.cType === 'TL'
                      ? ''
                      : 'linear-gradient(135deg, #6D5DFB, #46C8FF)',
                  '& img': {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: '50%',
                    backgroundColor: row.original.cType === 'TL' ? '' : '#fff',
                    padding: 0
                  }
                }}
              />
            </AvatarGroup>
          </Box>
          {userPermissionsArr &&
            (UserIsAdmin ||
              userPermissionsArr?.some(
                permissions =>
                  permissions.permissionName === 'TL Carriers' &&
                  (permissions.level2 || permissions.level4)
              )) &&
            value == '2' && (
              <div
                className={
                  isMobile
                    ? 'table-row-buttons-users-mobile py-0'
                    : 'table-row-buttons-users py-1'
                }
                style={
                  isMobile
                    ? { marginLeft: '-70px', position: 'absolute' }
                    : { left: '8px', position: 'absolute' }
                }
              >
                <button
                  onClick={event => {
                    setCreateUpdateCarrier(true);
                    history.push('/create-carrier', row.original);
                  }}
                  className={
                    isMobile
                      ? 'bg-grey border-0 p-2 fw-bold'
                      : 'bg-white border-0 p-2 fw-bold'
                  }
                  style={{
                    color: '#3361FF',
                    borderRadius: '4px',
                    margin: '0 0 0 40'
                  }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='mx-0'
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Tooltip>
                </button>
              </div>
            )}
          {canShowSettings && row.original.active && (
            <div
              className={
                isMobile
                  ? 'table-row-buttons-users-mobile py-2'
                  : 'table-row-buttons-users py-2'
              }
              style={
                isMobile
                  ? { marginLeft: '-30px', position: 'absolute' }
                  : { marginLeft: '-2vw', position: 'absolute' }
              }
            >
              <Tooltip arrow title='Settings'>
                <SettingsIcon
                  style={{ color: '#3361FF' }}
                  sx={{ cursor: 'pointer', marginRight: 2 }}
                  onClick={e => handleUpdateCarrier(e, row.original)}
                />
              </Tooltip>
            </div>
          )}
        </>
      )
    },
    {
      accessorKey: 'name',
      id: 'name',
      header: 'Carrier Name'
    },
    {
      accessorKey: 'contactEmail',
      id: 'contactEmail',
      header: 'Carrier Email'
    },
    {
      accessorKey: 'active',
      id: 'active',
      header: 'Carrier Status',
      Cell: ({ renderedCellValue, row }) => (
        <>
          {
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {renderedCellValue ? 'Active' : 'In-Active'}
            </Box>
          }
        </>
      )
    },
    {
      accessorKey: 'cSubType',
      id: 'cSubType',
      header: 'SubType'
    },

    {
      accessorKey: 'thirdPartyAccountNumber',
      id: 'thirdPartyAccountNumber',
      header: '3rd Party Account'
    },
    {
      accessorKey: 'proNumberSeries',
      id: 'proNumberSeries',
      header: 'ProNumber Series',
      Cell: ({ row }) => {
        const proNumberStart = row.original.proNumberStart;
        const proNumberEnd = row.original.proNumberEnd;
        const hasSeries = proNumberStart && proNumberEnd;

        return (
          <Box
            sx={{
              width: hasSeries ? '100%' : '80%',
              textAlign: hasSeries ? 'left' : 'center'
            }}
          >
            {hasSeries ? `${proNumberStart} - ${proNumberEnd}` : '-'}
          </Box>
        );
      }
    },
    {
      accessorKey: 'proNumberTotals',
      id: 'proNumberTotals',
      header: 'Total ProNumbers',
      size: 50
    },
    {
      accessorKey: 'proNumberConsumed',
      id: 'proNumberConsumed',
      header: 'Consumed ProNumbers',
      size: 50,
      Cell: ({ row }) => {
        return (
          <Box
            sx={{
              width: '100%',
              textAlign: 'left'
            }}
          >
            {row.original.proNumberTotals &&
              row.original.proNumberLeft &&
              calculateConsumed(
                row.original.proNumberTotals,
                row.original.proNumberLeft
              )}
          </Box>
        );
      }
    },
    {
      accessorKey: 'proNumberLeft',
      id: 'proNumberLeft',
      header: <div style={{ whiteSpace: 'nowrap' }}>Remaining ProNumbers</div>
    }
  ];

  const [value, setValue] = useState('1');
  const [columnsData, setColumnsData] = useState(mncolumns);

  useEffect(() => {
    if (!isNewUI && props?.location?.state === 'Non-LTL') {
      setValue('2');
      selectedTab.current = 2;
      handleChange('event', '2');
      // setTLCarriers(TLcarriers);
    }
  }, []);

  const canShowSettings = useMemo(() => {
    if (UserIsAdmin && (value == '1' || value == '3')) return true;
    return userPermissionsArr.some(
      p =>
        ((value == '1' && p.permissionName.includes('LTL Carriers')) ||
          (value == '3' && p.permissionName.includes('Parcel Carriers'))) &&
        p.level2
    );
  }, [userPermissionsArr, value, UserIsAdmin]);

  useEffect(() => {
    // const filteredCol = mncolumns;
    if (selectedTab.current == '1' || selectedTab.current == '3') {
      const filteredCol = mncolumns.filter(col => {
        return (
          col.accessorKey !== 'contactEmail' &&
          col.accessorKey !== 'cSubType' &&
          col.accessorKey !== 'active'
        );
      });
      setColumnsData(filteredCol);
    }
    if (selectedTab.current == '2') {
      const filteredCol = mncolumns.filter(col => {
        return (
          col.accessorKey !== 'thirdPartyAccountNumber' &&
          col.accessorKey !== 'proNumberSeries' &&
          col.accessorKey !== 'proNumberConsumed' &&
          col.accessorKey !== 'proNumberLeft' &&
          col.accessorKey !== 'proNumberTotals'
        );
      });
      setColumnsData(filteredCol);
    }
  }, [selectedTab, value, carriers, LTLCarriers, TLcarriers, parcelCarriers]);

  const handleSurchargeChange = (event, newValue) => {
    if (newValue.includes('All')) {
      // If "All" is selected, select everything
      setSelectedOptions(surchargeTypeArr.filter(items => items !== 'All'));
    } else {
      // If "All" is removed, deselect it and update the state
      setSelectedOptions(newValue.filter(option => option !== 'All'));
    }
  };
  const handleChange = (event, newValue) => {
    // event.stopPropagation();
    console.log(newValue, 'newValue---');
    selectedTab.current = newValue;
    const filteredCol = mncolumns;
    setValue(newValue);
    if (newValue == '1') {
      setColumnsData(filteredCol);
      setCarriers(LTLCarriers);
    }
    if (newValue == '2') {
      const filteredCol = columnsData.filter(col => {
        return (
          col.accessorKey !== 'thirdPartyAccountNumber' &&
          col.accessorKey !== 'proNumberSeries' &&
          col.accessorKey !== 'proNumberConsumed' &&
          col.accessorKey !== 'proNumberLeft' &&
          col.accessorKey !== 'proNumberTotals' &&
          col.accessorKey !== 'cSubType'
        );
      });
      setColumnsData(filteredCol);
      setCarriers(TLcarriers);
    }
    if (newValue == '3') {
      setColumnsData(filteredCol);
      setCarriers(parcelCarriers);
    }
  };
  const handleProNumberFromChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNmbChanged(true);
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberFrom: null
      });
      setProNumberFrom(inputValue);
    } else {
      setProNmbChanged(false);
      setProNumberFrom('');
    }
  };

  const handleProNumberToChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNmbChanged(true);
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberTo: null
      });
      setProNumberTo(inputValue);
    } else {
      setProNmbChanged(false);

      setProNumberTo('');
    }
  };

  const handleProNumberAlertChange = e => {
    const inputValue = e.target.value;
    const isValidInput = /^[0-9]\d*$/.test(inputValue);
    if (isValidInput) {
      setProNumbersErrors({
        ...proNumberErrors,
        proNumberAlert: null
      });
      setProNumberAlert(inputValue);
    } else {
      setProNumberAlert('');
    }
  };

  const handleCarrierTabChange = (event, newValue) => {
    setCarrierTabValue(newValue);
  };
  const handleSurchargeRequest = () => {
    const surchargeObj = {
      id: carrierID,
      surcharge: surchargeValue ? Number(surchargeValue) : 0,
      surchargeType: surchargeType ? surchargeType : '',
      surchargeApplyOn: selectedOptions.join(',')
    };

    UpdateCarrierSurcharge(surchargeObj)
      .then(res => {
        res.status === 200 && successToast('Surcharge Value Updated!');
        handleSuccessGetCarriers('Updated');
        // if (isNewUI) {
        //   handleClose();
        // }
        // else {
        //   handleClose();
        // }

        setOpen(false);
        // setTimeout(() => {
        //   setCarrierTabValue('1');
        // }, 2000);
      })
      .catch(err => ErrorToast(err?.message));
  };
  const handleClaimSettingsRequest = () => {
    const claimObj = {
      carrierId: claimSettingsObj.carrierId ? claimSettingsObj.carrierId : 0,
      contactName: claimSettingsObj.contactName
        ? claimSettingsObj.contactName
        : '',
      contactEmail: claimSettingsObj.contactEmail
        ? claimSettingsObj.contactEmail
        : '',
      contactPhone: claimSettingsObj.contactPhone
        ? claimSettingsObj.contactPhone
        : '',
      copyTo: claimSettingsObj.copyTo ? claimSettingsObj.copyTo : ''
    };
    if (claimSettingsObj.contactName === '') {
      setErrors(prev => ({
        ...prev,
        contactName: 'Contact name is required'
      }));
    }
    if (
      claimSettingsObj.contactName &&
      claimSettingsObj.contactEmail &&
      claimSettingsObj.contactPhone
    ) {
      UpdateCarrierClaimSettings(claimObj)
        .then(res => {
          res.status === 200 && successToast('Claim Settings Updated!');
          handleSuccessGetCarriers('Updated');
          // if (isNewUI) {
          //   fetchCarriers();
          //   selectedCarrier.current = {};
          // }

          setOpen(false);
          // setTimeout(() => {
          //   setCarrierTabValue('1');
          // }, 2000);
        })
        .catch(err => ErrorToast(err?.message));
    }
  };
  const handleInvoiceThreshold = () => {
    const thrsholdApiObj = {
      id: carrierID,
      type: thresholdType,
      threshold: thresholdValue ? thresholdValue : 0
    };

    UpdateCarrierInvoiceAuditThreshold(thrsholdApiObj)
      .then(res => {
        res.status === 200 && handleSuccessGetCarriers();
        successToast('Threshold applied successfully!');
        if (!isNewUI) {
          handleClose();

          // selectedCarrier.current = {};
        }
        //  else {
        //   handleClose();
        // }
      })
      .catch(err => {
        ErrorToast(err?.message);
        console.log(err, 'err ------>>>>');
      });
  };

  const ValidatePhoneNumber = phNumber => {
    const inputValue = phNumber;

    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');

    setThirdPatyAccDetails(oldObj => ({
      ...oldObj,
      phoneNumber: formattedValue
    }));

    // Perform validation on the formatted value
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber || inputValue === '') {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberErrorBT: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberErrorBT'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const ValidateEmailAddress = emValue => {
    const emailRegex =
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,[\s]*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;

    const errors = {};
    setThirdPatyAccDetails(oldObj => ({
      ...oldObj,
      emailAddress: emValue
    }));

    if (emailRegex.test(emValue) || emValue === '') {
      setIsValidEmail(true);
      setValidationErrors({
        ...validationErrors,
        emailErrorBT: null
      });
    } else {
      setIsValidEmail(false);
      errors['emailErrorBT'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };

  const handleThirdPartyRequest = () => {
    ValidateEmailAddress(thirdPatyAccDetails.emailAddress);
    if (isValidEmail) {
      ValidatePhoneNumber(thirdPatyAccDetails.phoneNumber);
      if (!phoneNumberValidError) {
        UpdateCarrierThirdPartyInfo(thirdPatyAccDetails)
          .then(res => {
            GetCarriers(AgencyID)
              .then(
                res =>
                  res.status === 200 &&
                  handleSuccessCarriersStateFlow(res, 'LTL', 'Updated')
              )
              .catch(err => console.log(err, 'err'));
            res.status === 200 &&
              successToast('3rd party account updated successfully!');
            if (!isNewUI) {
              handleClose();
            }
            // selectedCarrier.current = {};
            setOpen(false);
            // setTimeout(() => {
            // setCarrierTabValue('1');
            // }, 2000);
          })
          .catch(err => {
            ErrorToast(err?.message);
            setOpen(false);
            // setTimeout(() => {
            // setCarrierTabValue('1');
            // }, 2000);
          });
      }
    }
  };

  const handleRemainingPro = () => {
    if (proNumberTo - proNumberFrom > 0) {
      return proNumberTo - proNumberFrom + 1;
    } else return 0;
  };
  const handleEmailValidation = email => {
    const emailRegex =
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(,[\s]*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/;

    const errors = {};
    setEmail(email);

    if (emailRegex.test(email) || email === '') {
      setIsValidEmail(true);
      setValidationErrors({
        ...validationErrors,
        emailError: null
      });
    } else {
      setIsValidEmail(false);
      errors['emailError'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };
  const handleRateQuoteSettingsReq = () => {
    const carrierRateSettingsObj = {
      id: carrierID,
      type: secondPaymentTerms === 'Both' ? secondPaymentTerms : paymentTerms,
      typeDetail: secondPaymentTerms === 'Both' ? secondRatesType : ratesType,
      typeDetailFilter:
        secondPaymentTerms === 'Both'
          ? secondRatesType === 'Guaranteed'
            ? secondGuaranteedType
            : ''
          : ratesType === 'Guaranteed'
            ? guaranteedType
            : '',
      type2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondPaymentTerms,
      typeDetail2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondRatesType,
      typeDetailFilter2:
        paymentTerms === 'Both' || secondPaymentTerms === 'Both'
          ? ''
          : secondRatesType === 'Guaranteed'
            ? secondGuaranteedType
            : ''
    };
    UpdateCarrierRateQuoteSettings(carrierRateSettingsObj)
      .then(res => {
        res.status === 200 && successToast('Rate Quote Settings Updated!');
        handleSuccessGetCarriers('Updated');
        // if (!isNewUI) {
        //   handleClose();

        //   // fetchCarriers();
        // } else {
        //   handleClose();
        // }
        // selectedCarrier.current = {};
      })

      .catch(err => ErrorToast(err?.message));

    setOpen(false);
    // setTimeout(() => {
    //   setCarrierTabValue('1');
    // }, 2000);
  };

  const handleBackToList = e => {
    setListView(true);
    // handleClose();
  };

  const rateQuoteUIhandler = (type, name) => {
    if (type === 'Guaranteed') {
      if (
        configuredCarrierName === 'FedEx' ||
        configuredCarrierName === 'UPS'
      ) {
        return name === 'xs' || name === 'sm' ? 12 : 3;
      } else return name === 'xs' || name === 'sm' ? 12 : 4;
    } else if (
      configuredCarrierName === 'FedEx' ||
      configuredCarrierName === 'UPS'
    ) {
      return name === 'xs' || name === 'sm' ? 12 : 4;
    } else return name === 'xs' || name === 'sm' ? 12 : 6;
  };

  const checkCarrierPermissions = () => {
    if (selectedTab.current == '1') {
      // LTL Carriers check
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          (userPermissionsArr.filter(
            permissions =>
              permissions.level3 &&
              permissions.permissionName === 'LTL Carriers'
          ).length ||
            userPermissionsArr.filter(
              permissions =>
                permissions.level4 &&
                permissions.permissionName === 'LTL Carriers'
            ).length))
      );
    } else if (selectedTab.current == '3') {
      // Parcel Carriers check
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          (userPermissionsArr.filter(
            permissions =>
              permissions.level3 &&
              permissions.permissionName === 'Parcel Carriers'
          ).length ||
            userPermissionsArr.filter(
              permissions =>
                permissions.level4 &&
                permissions.permissionName === 'Parcel Carriers'
            ).length))
      );
    }
    // Default fallback to original logic
    return (
      UserIsAdmin ||
      (userPermissionsArr &&
        (userPermissionsArr.filter(permissions => permissions.level3).length ||
          userPermissionsArr.filter(permissions => permissions.level4).length))
    );
  };

  // For level4 only checks (Third Party Settings)
  const checkCarrierPermissionsLevel4 = () => {
    if (selectedTab.current == '1') {
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          userPermissionsArr.filter(
            permissions =>
              permissions.level4 &&
              permissions.permissionName === 'LTL Carriers'
          ).length)
      );
    } else if (selectedTab.current == '3') {
      return (
        UserIsAdmin ||
        (userPermissionsArr &&
          userPermissionsArr.filter(
            permissions =>
              permissions.level4 &&
              permissions.permissionName === 'Parcel Carriers'
          ).length)
      );
    }
    return (
      UserIsAdmin ||
      (userPermissionsArr &&
        userPermissionsArr.filter(permissions => permissions.level4).length)
    );
  };
  const handleTabChange = (event, newValue) => {
    console.log(newValue, 'newValue');
    selectedTab.current = newValue;
    selectedCarrier.current = {};
    handleClose();
    if (newValue == 1) {
      setCarriers(LTLCarriers);
      // selectedCarrier.current = (LTLCarriers[0]);
    } else if (newValue == 2) {
      setCarriers(TLcarriers);
      // selectedCarrier.current = (TLcarriers[0]);
    } else {
      // selectedCarrier.current = (parcelCarriers[0]);

      setCarriers(parcelCarriers);
    }
  };
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const [sortOrder, setSortOrder] = useState('asc');

  // Filter and sort logic
  const filteredCarriers = useMemo(() => {
    // First, determine which carrier list to use based on either selectedTab or selectedCarrier
    let carrierList = carriers;
    console.log(selectedTab.current, 'selectedTab.current');
    if (selectedTab.current) {
      // If using tabs for carrier type selection
      switch (selectedTab.current) {
        case 1:
          carrierList = LTLCarriers;
          break;
        case 2:
          carrierList = TLcarriers;
          break;
        case 3:
          carrierList = parcelCarriers;
          break;
        default:
          carrierList = carriers;
      }
    } else if (selectedCarrier?.current?.cType) {
      // Fallback to selectedCarrier if no tabs are used
      switch (selectedCarrier.current.cType) {
        case 'TL':
          carrierList = TLcarriers;
          break;
        case 'LTL':
          carrierList = LTLCarriers;
          break;
        case 'Parcel':
          carrierList = parcelCarriers;
          break;
        default:
          carrierList = carriers;
      }
    }
    console.log(carrierList, 'carrierList');
    // Apply search filter
    let filtered = carrierList.filter(carrier => {
      if (!searchTerm) return true;

      const searchLower = searchTerm.toLowerCase();
      return (
        carrier.name?.toLowerCase().includes(searchLower) ||
        carrier.contactEmail?.toLowerCase().includes(searchLower) ||
        carrier.thirdPartyAccountNumber?.toLowerCase().includes(searchLower) ||
        carrier.surcharge?.toString().includes(searchLower) ||
        carrier.surchargeType?.toLowerCase().includes(searchLower) ||
        carrier.surchargeApplyOn?.toLowerCase().includes(searchLower) ||
        carrier.cSubType?.toLowerCase().includes(searchLower) ||
        carrier.rqSettingTypeInfo?.toLowerCase().includes(searchLower) ||
        carrier.rqSettingType?.toLowerCase().includes(searchLower)
      );
    });

    // Sort logic (same as before)
    filtered.sort((a, b) => {
      let aValue, bValue;

      switch (sortBy) {
        case 'name':
          aValue = a.name || '';
          bValue = b.name || '';
          break;
        case 'total':
          aValue = a.proNumberTotals;
          bValue = b.proNumberTotals;
          break;
        case 'consumed':
          aValue = calculateConsumed(a.proNumberTotals, a.proNumberLeft);
          bValue = calculateConsumed(b.proNumberTotals, b.proNumberLeft);
          break;
        case 'remaining':
          aValue = a.proNumberLeft;
          bValue = b.proNumberLeft;
          break;
        case 'surcharge':
          aValue = parseFloat(a.surcharge) || 0;
          bValue = parseFloat(b.surcharge) || 0;
          break;
        default:
          aValue = a.name || '';
          bValue = b.name || '';
      }

      if (sortOrder === 'asc') {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });

    return filtered;
  }, [
    carriers,
    searchTerm,
    sortBy,
    sortOrder,
    selectedCarrier,
    TLcarriers,
    LTLCarriers,
    parcelCarriers,
    forceUpdateCounter
  ]);

  const handleSort = field => {
    if (sortBy === field) {
      // Toggle order if same field
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new field with default order
      setSortBy(field);
      setSortOrder(field === 'name' ? 'asc' : 'desc');
    }
  };

  const getSortLabel = () => {
    const labels = {
      name: 'Name',
      consumed: 'Consumed',
      remaining: 'Remaining',
      surcharge: 'Surcharge'
    };
    const order = sortOrder === 'asc' ? 'Ascending' : 'Descending';
    return `${labels[sortBy]} • ${order}`;
  };

  const CarrierCard = ({ items, selected, onSelect, selectedTab }) => {
    const consumed = calculateConsumed(
      items.proNumberTotals,
      items.proNumberLeft
    );
    const remaining = items.proNumberLeft;
    const total = consumed + remaining;
    const progress = (consumed / total) * 100;
    const theme = useTheme();
    const isLaptop = useMediaQuery('(max-width:1600px)');

    return (
      <Card
        variant='outlined'
        onClick={onSelect}
        sx={{
          p: 1.5,
          mb: 2,
          borderRadius: 2,
          width: '100%',
          minHeight: '190px',
          mx: 'auto',
          transition: 'all 0.11s ease',
          background: selected
            ? '#f8f9ff' // Solid light blue background
            : '#fff',
          border: selected ? '1.3px solid #5a4bfa' : '1px solid #ddd',
          boxShadow: selected
            ? '0 0 12px rgba(109,93,251,0.25)'
            : '0 1px 3px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
            cursor: 'pointer'
          },
          minWidth: '280px'
        }}
      >
        {/* Header Section */}
        <Grid container alignItems='center' spacing={1}>
          <Grid item xs={12} sm='auto' textAlign={{ xs: 'center', sm: 'left' }}>
            <Avatar
              variant='circular'
              alt={items.name}
              src={base_logo_url + items.logo}
              sx={{
                width: { xs: 40, sm: 60 },
                height: { xs: 40, sm: 60 },
                mx: { xs: 'auto', sm: 0 },
                p: '2px',
                background: 'linear-gradient(135deg, #6D5DFB, #46C8FF)',
                '& img': {
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  padding: 0
                }
              }}
            />
          </Grid>

          {items.cType === 'TL' ? (
            <Grid item xs>
              <Box flexWrap='wrap' gap={2} sx={{ minHeight: '32px' }}>
                <Typography fontWeight={700} fontSize='0.95rem' noWrap>
                  {items.name}
                </Typography>

                <Tooltip arrow placement='top' title={items.contactEmail}>
                  <Typography
                    variant='body2'
                    fontWeight={400}
                    fontSize='0.85rem'
                    noWrap
                  >
                    {items.contactEmail?.split(',')[0].trim()}
                  </Typography>
                </Tooltip>
              </Box>
            </Grid>
          ) : (
            <Grid item xs>
              {/* E-Pros Stats */}
              <Box
                display='flex'
                justifyContent='space-between'
                alignItems='center'
                flexWrap='wrap'
              >
                <Typography fontWeight={700} fontSize='0.95rem' noWrap>
                  E-Pros
                </Typography>

                <Box display='flex' alignItems='center' gap={1}>
                  {/* Total PRO */}
                  <Tooltip arrow placement='top' title='Total PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(25, 118, 210, 0.1)',
                        border: '1px solid rgba(25, 118, 210, 0.2)'
                      }}
                    >
                      <NumbersIcon
                        sx={{
                          fontSize: '0.9rem',
                          color: '#1976d2'
                        }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {total}
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* Consumed PRO */}
                  <Tooltip arrow placement='top' title='Consumed PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(244, 67, 54, 0.1)',
                        border: '1px solid rgba(244, 67, 54, 0.2)'
                      }}
                    >
                      <RemoveCircleOutlineIcon
                        sx={{
                          fontSize: '0.9rem',
                          color: '#f44336'
                        }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {consumed}
                      </Typography>
                    </Box>
                  </Tooltip>

                  {/* Remaining PRO */}
                  <Tooltip arrow placement='top' title='Remaining PRO'>
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      sx={{
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                        border: '1px solid rgba(76, 175, 80, 0.2)'
                      }}
                    >
                      <CheckCircleOutlineIcon
                        sx={{
                          fontSize: '0.9rem',
                          color: '#4caf50'
                        }}
                      />
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {remaining}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Box>

              {/* Progress Bar */}
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: 6,
                  my: 1,
                  borderRadius: 4,
                  backgroundColor: '#e0e0e0',
                  '& .MuiLinearProgress-bar': { backgroundColor: '#2196f3' }
                }}
              />

              {/* Account and Surcharge Info */}
              <Grid
                display={'flex'}
                justifyContent='space-between'
                spacing={0}
                sx={{
                  mt: 1.5,
                  gap: 1
                }}
              >
                <Grid>
                  <Box
                    display='flex'
                    alignItems='center'
                    gap={0.5}
                    flexWrap='wrap'
                  >
                    <Tooltip arrow placement='top' title='Third Party Account'>
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        3PA#:
                      </Typography>
                    </Tooltip>
                    <Typography
                      variant='body2'
                      fontWeight={400}
                      fontSize='0.85rem'
                      noWrap
                    >
                      {items.thirdPartyAccountNumber || 'N/A'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid>
                  <Tooltip
                    title={items.surchargeApplyOn || 'N/A'}
                    arrow
                    placement='top'
                  >
                    <Box
                      display='flex'
                      alignItems='center'
                      gap={0.5}
                      flexWrap='wrap'
                      justifyContent='flex-end'
                    >
                      <Typography
                        variant='body2'
                        fontWeight={600}
                        fontSize='0.85rem'
                        noWrap
                      >
                        Surcharge:
                      </Typography>
                      <Typography
                        variant='body2'
                        fontWeight={400}
                        fontSize='0.85rem'
                        noWrap
                      >
                        {items.surcharge || '0'}
                        {items.surchargeType || '$'}
                      </Typography>
                    </Box>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>

        <Divider
          sx={{
            my: 1,
            borderBottomWidth: 2,
            opacity: 0.3
          }}
        />

        {/* Checkbox Sections */}
        {items.cType === 'TL' ? (
          <Box
            sx={{
              flexWrap: 'wrap'
            }}
          >
            <Typography
              variant='subtitle2'
              fontWeight='bold'
              fontSize='0.9rem'
              gutterBottom
              noWrap
            >
              Subtype
            </Typography>

            <Box display='flex' flexWrap='wrap' alignItems='center' gap={1}>
              {items.cSubType
                ?.split(',')
                .map(type => type.trim())
                .filter(Boolean)
                .map((type, index) => (
                  <Box key={index} display='flex' alignItems='center' gap={0.5}>
                    <Checkbox
                      disabled
                      size='small'
                      checked
                      sx={{
                        padding: '4px',
                        color: 'green',
                        '&.Mui-checked': { color: 'green' },
                        '& .MuiSvgIcon-root': {
                          fontSize: '1.1rem',
                          backgroundColor: 'white',
                          borderRadius: '3px'
                        }
                      }}
                    />
                    <Typography variant='body2' fontSize='0.85rem' noWrap>
                      {type}
                    </Typography>
                  </Box>
                ))}
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              p: 1,
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              backgroundColor: '#f5f5f5'
            }}
          >
            {/* Row 1 */}
            {(items.rqSettingType ||
              items.rqSettingTypeInfo ||
              items.rqSettingTypeFilter) && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flexWrap: 'wrap'
                }}
              >
                {/* Shipment Type */}
                {items.rqSettingType && items.rqSettingType !== '' && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {items.rqSettingType === 'Both' ? (
                      <>
                        <Box display='flex' alignItems='center' mr={0.5}>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#4caf50',
                              '&.Mui-checked': { color: '#4caf50' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Inbound
                          </Typography>
                        </Box>
                        <Box display='flex' alignItems='center'>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#4caf50',
                              '&.Mui-checked': { color: '#4caf50' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Outbound
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <Box display='flex' alignItems='center'>
                        <Checkbox
                          disabled
                          size='small'
                          checked
                          sx={{
                            color: '#4caf50',
                            '&.Mui-checked': { color: '#4caf50' },
                            p: 0,
                            '& .MuiSvgIcon-root': { fontSize: '1rem' }
                          }}
                        />
                        <Typography variant='body2' fontSize='0.75rem'>
                          {items.rqSettingType}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Arrow */}
                {(items.rqSettingType || items.rqSettingTypeInfo) &&
                  items.rqSettingTypeInfo &&
                  items.rqSettingTypeInfo !== '' && (
                    <Typography
                      variant='body2'
                      color='text.disabled'
                      sx={{ fontSize: '0.75rem' }}
                    >
                      →
                    </Typography>
                  )}

                {/* Rate Type Info */}
                {items.rqSettingTypeInfo && items.rqSettingTypeInfo !== '' && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {items.rqSettingTypeInfo === 'All' ? (
                      <>
                        <Box display='flex' alignItems='center' mr={0.5}>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#2196f3',
                              '&.Mui-checked': { color: '#2196f3' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Standard
                          </Typography>
                        </Box>
                        <Box display='flex' alignItems='center'>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#ff9800',
                              '&.Mui-checked': { color: '#ff9800' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Guaranteed
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <Box display='flex' alignItems='center'>
                        <Checkbox
                          disabled
                          size='small'
                          checked
                          sx={{
                            color:
                              items.rqSettingTypeInfo === 'Standard'
                                ? '#2196f3'
                                : '#ff9800',
                            '&.Mui-checked': {
                              color:
                                items.rqSettingTypeInfo === 'Standard'
                                  ? '#2196f3'
                                  : '#ff9800'
                            },
                            p: 0,
                            '& .MuiSvgIcon-root': { fontSize: '1rem' }
                          }}
                        />
                        <Typography variant='body2' fontSize='0.75rem'>
                          {items.rqSettingTypeInfo}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Arrow */}
                {(items.rqSettingTypeInfo || items.rqSettingTypeFilter) &&
                  items.rqSettingTypeFilter &&
                  items.rqSettingTypeFilter !== '' && (
                    <Typography
                      variant='body2'
                      color='text.disabled'
                      sx={{ fontSize: '0.75rem' }}
                    >
                      →
                    </Typography>
                  )}

                {/* Filter */}
                {items.rqSettingTypeFilter &&
                  items.rqSettingTypeFilter !== '' && (
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        bgcolor:
                          items.rqSettingTypeFilter === 'Quickest'
                            ? '#e3f2fd'
                            : '#f5f5f5',
                        px: 1,
                        py: 0.3,
                        borderRadius: 1,
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      <Typography
                        variant='body2'
                        fontSize='0.75rem'
                        fontWeight='medium'
                      >
                        {items.rqSettingTypeFilter}
                      </Typography>
                    </Box>
                  )}
              </Box>
            )}

            {/* Row 2 */}
            {(items.rqSettingType2 ||
              items.rqSettingTypeInfo2 ||
              items.rqSettingTypeFilter2) && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  flexWrap: 'wrap'
                }}
              >
                {/* Shipment Type 2 */}
                {items.rqSettingType2 && items.rqSettingType2 !== '' && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {items.rqSettingType2 === 'Both' ? (
                      <>
                        <Box display='flex' alignItems='center' mr={0.5}>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#4caf50',
                              '&.Mui-checked': { color: '#4caf50' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Inbound
                          </Typography>
                        </Box>
                        <Box display='flex' alignItems='center'>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color: '#4caf50',
                              '&.Mui-checked': { color: '#4caf50' },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            Outbound
                          </Typography>
                        </Box>
                      </>
                    ) : (
                      <Box display='flex' alignItems='center'>
                        <Checkbox
                          disabled
                          size='small'
                          checked
                          sx={{
                            color: '#4caf50',
                            '&.Mui-checked': { color: '#4caf50' },
                            p: 0,
                            '& .MuiSvgIcon-root': { fontSize: '1rem' }
                          }}
                        />
                        <Typography variant='body2' fontSize='0.75rem'>
                          {items.rqSettingType2}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Arrow */}
                {(items.rqSettingType2 || items.rqSettingTypeInfo2) &&
                  items.rqSettingTypeInfo2 &&
                  items.rqSettingTypeInfo2 !== '' && (
                    <Typography
                      variant='body2'
                      color='text.disabled'
                      sx={{ fontSize: '0.75rem' }}
                    >
                      →
                    </Typography>
                  )}

                {/* Rate Type Info 2 */}
                {items.rqSettingTypeInfo2 &&
                  items.rqSettingTypeInfo2 !== '' && (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {items.rqSettingTypeInfo2 === 'All' ? (
                        <>
                          <Box display='flex' alignItems='center' mr={0.5}>
                            <Checkbox
                              disabled
                              size='small'
                              checked
                              sx={{
                                color: '#2196f3',
                                '&.Mui-checked': { color: '#2196f3' },
                                p: 0,
                                '& .MuiSvgIcon-root': { fontSize: '1rem' }
                              }}
                            />
                            <Typography variant='body2' fontSize='0.75rem'>
                              Standard
                            </Typography>
                          </Box>
                          <Box display='flex' alignItems='center'>
                            <Checkbox
                              disabled
                              size='small'
                              checked
                              sx={{
                                color: '#ff9800',
                                '&.Mui-checked': { color: '#ff9800' },
                                p: 0,
                                '& .MuiSvgIcon-root': { fontSize: '1rem' }
                              }}
                            />
                            <Typography variant='body2' fontSize='0.75rem'>
                              Guaranteed
                            </Typography>
                          </Box>
                        </>
                      ) : (
                        <Box display='flex' alignItems='center'>
                          <Checkbox
                            disabled
                            size='small'
                            checked
                            sx={{
                              color:
                                items.rqSettingTypeInfo2 === 'Standard'
                                  ? '#2196f3'
                                  : '#ff9800',
                              '&.Mui-checked': {
                                color:
                                  items.rqSettingTypeInfo2 === 'Standard'
                                    ? '#2196f3'
                                    : '#ff9800'
                              },
                              p: 0,
                              '& .MuiSvgIcon-root': { fontSize: '1rem' }
                            }}
                          />
                          <Typography variant='body2' fontSize='0.75rem'>
                            {items.rqSettingTypeInfo2}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}

                {/* Arrow */}
                {(items.rqSettingTypeInfo2 || items.rqSettingTypeFilter2) &&
                  items.rqSettingTypeFilter2 &&
                  items.rqSettingTypeFilter2 !== '' && (
                    <Typography
                      variant='body2'
                      color='text.disabled'
                      sx={{ fontSize: '0.75rem' }}
                    >
                      →
                    </Typography>
                  )}

                {/* Filter 2 */}
                {items.rqSettingTypeFilter2 &&
                  items.rqSettingTypeFilter2 !== '' && (
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        bgcolor:
                          items.rqSettingTypeFilter2 === 'Quickest'
                            ? '#e3f2fd'
                            : '#f5f5f5',
                        px: 1,
                        py: 0.3,
                        borderRadius: 1,
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      <Typography
                        variant='body2'
                        fontSize='0.75rem'
                        fontWeight='medium'
                      >
                        {items.rqSettingTypeFilter2}
                      </Typography>
                    </Box>
                  )}
              </Box>
            )}
          </Box>
        )}
      </Card>
    );
  };

  return (
    <Box
      // sx={{ overflowY: 'scroll' }}
      className={carriersLoader ? 'Box_Loader' : isMobile ? '' : 'Box_Parent'}
    >
      <MetaTags>
        <title>
          {' '}
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Carriers | Shiptechpro'
            : 'Carriers | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Grid>
        {/* E-Pro series dialog */}

        <Dialog
          PaperProps={{
            style: {
              minWidth: '60vw',
              height:
                Boolean(eproSeriesDataGenerate?.length) ||
                loadingEproSeriesGenerate
                  ? '70vh'
                  : 'auto'
            }
          }}
          className='InnerDialog'
          open={openEProDialogGenerate}
          onClose={handleCloseEProSeriesDialogGenerate}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {configuredCarrierName} E-Pro Series
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {/* <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Changes are un-revertible until it reached to the minimum Alert
                Level
              </Grid> */}
              <Grid
                className='h-100 w-100'
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                {Boolean(eproSeriesDataGenerate?.length) ||
                loadingEproSeriesGenerate ? (
                  <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                    <MaterialReactTable
                      data={eproSeriesDataGenerate}
                      columns={eproSeriesColumnsGenerate}
                      enableStickyHeader
                      enablePagination={false}
                      initialState={{
                        density: 'compact'
                      }}
                      muiTableContainerProps={{
                        sx: {
                          minWidth: '58vw',
                          maxWidth: '58vw',

                          maxHeight: '43vh',
                          minHeight: '43vh',
                          // height: '500px',
                          overflow: 'scroll'
                        }
                      }}
                      state={{
                        isLoading: loadingEproSeriesGenerate
                      }}
                      muiBottomToolbarProps={{
                        style: {
                          minHeight: 5,
                          maxHeight: 5
                          // display: 'none'
                        }
                      }}
                    />
                  </Grid>
                ) : (
                  <Alert className='w-100' severity='error'>
                    {eProSeriesGenerateError}
                  </Alert>
                )}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              color='error'
              onClick={handleCloseEProSeriesDialogGenerate}
            >
              Close
            </Button>
            {Boolean(eproSeriesDataGenerate?.length) && (
              <Button
                disabled={
                  (userPermissionsArr &&
                    (userPermissionsArr.filter(
                      permissions => permissions.level3
                    ).length ||
                      userPermissionsArr.filter(
                        permissions => permissions.level4
                      ).length)) ||
                  UserIsAdmin
                    ? false
                    : true
                }
                size='small'
                variant='contained'
                color='info'
                onClick={handleImportEProSeriesDialog}
              >
                Import
              </Button>
            )}
          </DialogActions>
        </Dialog>
        <Dialog
          PaperProps={{
            style: {
              minWidth: '60vw',
              height: '70vh'
            }
          }}
          className='InnerDialog'
          open={openEProDialog}
          onClose={handleCloseEProSeriesDialog}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {configuredCarrierName} E-Pro Series
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {/* <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Changes are un-revertible until it reached to the minimum Alert
                Level
              </Grid> */}
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                  <MaterialReactTable
                    data={eproSeriesData}
                    columns={eproSeriesColumns}
                    enableStickyHeader
                    enablePagination={false}
                    initialState={{
                      density: 'compact'
                    }}
                    muiTableContainerProps={{
                      sx: {
                        minWidth: '58vw',
                        maxWidth: '58vw',

                        maxHeight: '43vh',
                        minHeight: '43vh',
                        // height: '500px',
                        overflow: 'scroll'
                      }
                    }}
                    state={{
                      isLoading: loadingEproSeries
                    }}
                    muiBottomToolbarProps={{
                      style: {
                        minHeight: 5,
                        maxHeight: 5
                        // display: 'none'
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              color='error'
              onClick={handleCloseEProSeriesDialog}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={open && !isNewUI}
          onClose={handleClose}
          fullScreen={{ xs: true, sm: false }}
          PaperProps={{
            sx: {
              width: {
                xs: '100%',
                sm: '100%',
                md: '60vw',
                lg: '45vw'
              },
              height: {
                xs: '90vh',
                sm: 'auto',
                md: '60vh'
              },
              m: {
                xs: 0,
                sm: 2
              },
              borderRadius: {
                xs: 0,
                sm: 2
              },
              p: 2
            }
          }}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{`Configure ${configuredCarrierName} Settings`}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                  <TabContext value={carrierTabValue}>
                    <TabList
                      variant='scrollable'
                      scrollButtons={true}
                      allowScrollButtonsMobile
                      onChange={handleCarrierTabChange}
                      aria-label='carrier settings tabs'
                      sx={{
                        '& .MuiTab-root': {
                          whiteSpace: 'normal',
                          textAlign: 'center',
                          fontSize: {
                            xs: '0.7rem',
                            sm: '0.85rem',
                            md: '0.85rem',
                            lg: '0.85rem',
                            xl: '0.85rem'
                          },
                          lineHeight: 1.2,
                          padding: {
                            xs: '6px 3px',
                            sm: '8px 12px'
                          },
                          minWidth: {
                            xs: '1%',
                            sm: '29%',
                            md: '29%',
                            lg: '29%',
                            xl: '29%'
                          },
                          maxWidth: 150
                        }
                      }}
                    >
                      <Tab
                        disabled={!isEProSeriesGenerate}
                        label='Pro Number Settings'
                        value='1'
                      />
                      <Tab label='Third Party Settings' value='2' />
                      <Tab label='Surcharge Settings' value='3' />
                      <Tab label='Rate Quote Settings' value='4' />
                      <Tab label='Threshold Settings' value='5' />
                    </TabList>

                    <TabPanel value='1'>
                      <Grid sx={{ mt: 0 }} container spacing={0}>
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                          <FormControl fullWidth>
                            <InputLabel>Suffix </InputLabel>
                            <Select
                              disabled={!checkCarrierPermissions()}
                              label='Suffix '
                              fullWidth
                              size='small'
                              labelId='demo-simple-select-label'
                              id='demo-simple-select'
                              value={proNumberSuffixPosition}
                              onChange={handleChangeProNmb}
                            >
                              <MenuItem value={'Pre'}>Pre</MenuItem>
                              <MenuItem value={'Post'}>Post</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          sx={{
                            mt: {
                              xs: 1,
                              sm: 0,
                              md: 0,
                              lg: 0,
                              xl: 0
                            }
                          }}
                          xs={12}
                          sm={12}
                          md={8}
                          lg={8}
                          xl={8}
                        >
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            error={Boolean(
                              proNumberErrors['proNumberSuffixValue']
                            )}
                            helperText={proNumberErrors['proNumberSuffixValue']}
                            type='text'
                            fullWidth
                            label={`Enter ${proNumberSuffixPosition}`}
                            size='small'
                            value={proNumberSuffixValue}
                            onChange={e => {
                              setProNumberSuffixValue(e.target.value);
                              setProNumbersErrors({
                                ...proNumberErrors,
                                proNumberSuffixValue: null
                              });
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid sx={{ mt: 2 }} container spacing={0}>
                        <Grid item xs={6}>
                          <InputLabel sx={{ mb: 1, fontSize: 12 }}>
                            Enter Pro Number
                          </InputLabel>
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            required
                            inputProps={{ min: 0 }}
                            error={Boolean(proNumberErrors['proNumberFrom'])}
                            helperText={proNumberErrors['proNumberFrom']}
                            FormHelperTextProps={{
                              style: { margin: ' 5 0 0 0' }
                            }}
                            fullWidth
                            label='From'
                            size='small'
                            value={proNumberFrom}
                            onChange={e => handleProNumberFromChange(e)}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            inputProps={{ min: proNumberFrom }}
                            required
                            error={Boolean(proNumberErrors['proNumberTo'])}
                            helperText={proNumberErrors['proNumberTo']}
                            FormHelperTextProps={{
                              style: { margin: ' 5 0 0 0' }
                            }}
                            sx={{ mt: 3.2 }}
                            fullWidth
                            label='To'
                            size='small'
                            value={proNumberTo}
                            onChange={e => handleProNumberToChange(e)}
                          />
                        </Grid>
                      </Grid>
                      <Grid sx={{ mt: 2 }} container spacing={1}>
                        <Grid item xs={6} sm={6}>
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            required
                            error={Boolean(proNumberErrors['proNumberAlert'])}
                            helperText={proNumberErrors['proNumberAlert']}
                            FormHelperTextProps={{
                              style: { margin: ' 5 0 0 0' }
                            }}
                            inputProps={{ min: 1, max: proNumberTo }}
                            fullWidth
                            label='Enter minimum pro-number for Alert'
                            size='small'
                            value={proNumberAlert}
                            onChange={e => handleProNumberAlertChange(e)}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          className='d-flex justify-content-end'
                        >
                          <Button
                            variant='contained'
                            className=''
                            onClick={handleGenerateEProSeriesDialog}
                            disabled={!checkCarrierPermissions()}
                          >
                            Generate E-Pro Series
                          </Button>
                        </Grid>
                      </Grid>
                      {proNumberTo && (
                        <Grid sx={{ mt: 2 }} container spacing={1}>
                          <Grid item xs={6}>
                            <TextField
                              InputLabelProps={{ style: { color: 'black' } }}
                              disabled
                              InputProps={{
                                disableUnderline: true
                              }}
                              variant='standard'
                              fullWidth
                              label='Total Pro-Numbers'
                              size='small'
                              value={
                                !proNmbChanged && proNumberTotals
                                  ? proNumberTotals
                                  : handleRemainingPro()
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              InputLabelProps={{ style: { color: 'black' } }}
                              disabled
                              InputProps={{
                                disableUnderline: true
                              }}
                              variant='standard'
                              fullWidth
                              label='Remaining Pro-Numbers'
                              size='small'
                              value={
                                !proNmbChanged && proNumberLeft !== null
                                  ? proNumberLeft
                                  : handleRemainingPro()
                              }
                            />
                          </Grid>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          fullWidth
                          disabled={!checkCarrierPermissions()}
                          FormHelperTextProps={{
                            style: { margin: ' 5 30 0 0' }
                          }}
                          error={Boolean(validationErrors['emailError'])}
                          helperText={
                            validationErrors.emailError ||
                            (email &&
                              'To add multiple email addresses, please separate each address with a comma')
                          }
                          onChange={e => handleEmailValidation(e.target.value)}
                          value={email}
                          required
                          inputProps={{ style: { fontSize: 13 } }}
                          sx={{ mt: 3 }}
                          size='small'
                          label='Enter Email Address For Alert'
                          type='email'
                        />
                      </Grid>
                      <Button
                        variant='contained'
                        className='mt-3'
                        onClick={handleOpenEProSeriesDialog}
                      >
                        Show E-Pro Series
                      </Button>
                    </TabPanel>

                    <TabPanel value='2'>
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.thirdPartyAccountNumber}
                        fullWidth
                        sx={{ mt: 1 }}
                        label='Enter Third Party Account'
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            thirdPartyAccountNumber: e.target.value
                          })
                        }
                      />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.companyName}
                        fullWidth
                        sx={{ mt: 2 }}
                        label='Company Name'
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            companyName: e.target.value
                          })
                        }
                      />
                      <TextField
                        disabled={!checkCarrierPermissionsLevel4()}
                        value={thirdPatyAccDetails.streetLines}
                        fullWidth
                        sx={{ mt: 2 }}
                        label='Address'
                        size='small'
                        onChange={e =>
                          setThirdPatyAccDetails({
                            ...thirdPatyAccDetails,
                            streetLines: e.target.value
                          })
                        }
                      />
                      <Grid container sx={{ display: 'flex' }}>
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                          <TextField
                            disabled={!checkCarrierPermissionsLevel4()}
                            value={thirdPatyAccDetails.phoneNumber}
                            fullWidth
                            sx={{ mt: 2 }}
                            label='Phone Number'
                            size='small'
                            error={Boolean(
                              validationErrors['phoneNumberErrorBT']
                            )}
                            helperText={validationErrors['phoneNumberErrorBT']}
                            onChange={event =>
                              ValidatePhoneNumber(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                          <TextField
                            disabled={!checkCarrierPermissionsLevel4()}
                            value={thirdPatyAccDetails.emailAddress}
                            fullWidth
                            sx={{ mt: 2 }}
                            label='Email'
                            size='small'
                            type='email'
                            error={Boolean(validationErrors['emailErrorBT'])}
                            helperText={validationErrors['emailErrorBT']}
                            onChange={e => ValidateEmailAddress(e.target.value)}
                          />
                        </Grid>
                      </Grid>
                      <Grid sx={{ display: 'flex' }}>
                        <TextField
                          disabled={!checkCarrierPermissionsLevel4()}
                          value={thirdPatyAccDetails.city}
                          fullWidth
                          sx={{ mt: 2 }}
                          label='City'
                          size='small'
                          onChange={e =>
                            setThirdPatyAccDetails({
                              ...thirdPatyAccDetails,
                              city: e.target.value
                            })
                          }
                        />
                        <TextField
                          disabled={!checkCarrierPermissionsLevel4()}
                          value={thirdPatyAccDetails.state}
                          fullWidth
                          sx={{ mt: 2 }}
                          label='State'
                          size='small'
                          onChange={e =>
                            setThirdPatyAccDetails({
                              ...thirdPatyAccDetails,
                              state: e.target.value
                            })
                          }
                        />
                      </Grid>
                      <Grid sx={{ display: 'flex' }}>
                        <TextField
                          disabled={!checkCarrierPermissionsLevel4()}
                          value={thirdPatyAccDetails.postalCode}
                          fullWidth
                          sx={{ mt: 2 }}
                          label='Postal Code'
                          size='small'
                          onChange={e =>
                            setThirdPatyAccDetails({
                              ...thirdPatyAccDetails,
                              postalCode: e.target.value
                            })
                          }
                          type='number'
                        />
                        <TextField
                          disabled={!checkCarrierPermissionsLevel4()}
                          value={thirdPatyAccDetails.countryCode}
                          fullWidth
                          sx={{ mt: 2 }}
                          label='Country'
                          size='small'
                          onChange={e =>
                            setThirdPatyAccDetails({
                              ...thirdPatyAccDetails,
                              countryCode: e.target.value
                            })
                          }
                        />
                      </Grid>
                    </TabPanel>

                    <TabPanel value='3'>
                      <Grid sx={{ mt: 0 }} container spacing={0}>
                        <Grid item xs={9}>
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            type='number'
                            fullWidth
                            label='Enter Surcharge Value'
                            size='small'
                            value={surchargeValue}
                            onChange={e => setSurchargeValue(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel>Type </InputLabel>
                            <Select
                              disabled={!checkCarrierPermissions()}
                              label='Type '
                              fullWidth
                              size='small'
                              labelId='demo-simple-select-label'
                              id='demo-simple-select'
                              value={surchargeType}
                              onChange={e => setSurchargeType(e.target.value)}
                            >
                              <MenuItem value={'%'}>%</MenuItem>
                              <MenuItem value={'$'}>$</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid sx={{ mt: 2 }} item xs={12} sm={12}>
                        <Autocomplete
                          disabled={!checkCarrierPermissions()}
                          size='small'
                          multiple
                          options={surchargeTypeArr}
                          value={selectedOptions}
                          onChange={handleSurchargeChange}
                          renderInput={params => (
                            <TextField
                              size='small'
                              {...params}
                              variant='outlined'
                              label='Select Surcharge Types'
                              placeholder='Choose...'
                            />
                          )}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip
                                key={option}
                                label={option}
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                        />
                      </Grid>
                    </TabPanel>

                    <TabPanel value='4'>
                      {secondPaymentTerms !== 'Both' && (
                        <Grid sx={{ mt: 1 }} container spacing={1}>
                          <Grid
                            item
                            xs={rateQuoteUIhandler(ratesType, 'xs')}
                            sm={rateQuoteUIhandler(ratesType, 'sm')}
                            md={rateQuoteUIhandler(ratesType, 'md')}
                            lg={rateQuoteUIhandler(ratesType, 'lg')}
                            xl={rateQuoteUIhandler(ratesType, 'xl')}
                          >
                            <FormControl fullWidth>
                              <InputLabel>Select Shipment Type </InputLabel>
                              <Select
                                disabled={!checkCarrierPermissions()}
                                label='Select Shipment Type  '
                                fullWidth
                                size='small'
                                labelId='demo-simple-select-label'
                                id='demo-simple-select'
                                value={paymentTerms}
                                onChange={e => {
                                  setPaymentTerms(e.target.value);
                                  e.target.value === 'Inbound'
                                    ? setSecondPaymentTerms('OutBound')
                                    : setSecondPaymentTerms('Inbound');
                                }}
                              >
                                <MenuItem value={'Inbound'}>Inbound</MenuItem>
                                <MenuItem value={'OutBound'}>OutBound</MenuItem>
                                <MenuItem value={'Both'}>Both</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          {selectedTab.current == '3' &&
                          configuredCarrierName === 'UPS' ? (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={ratesType === 'Guaranteed' ? 3 : 4}
                              lg={ratesType === 'Guaranteed' ? 3 : 4}
                              xl={ratesType === 'Guaranteed' ? 3 : 4}
                            >
                              <FormControl fullWidth>
                                <InputLabel>Select Service Type </InputLabel>
                                <Select
                                  disabled={!checkCarrierPermissions()}
                                  label='Select Shipment Type  '
                                  fullWidth
                                  size='small'
                                  labelId='demo-simple-select-label'
                                  id='demo-simple-select'
                                  value={parcelServiceType}
                                  onChange={e => {
                                    setParcelServiceType(e.target.value);
                                  }}
                                >
                                  <MenuItem value={'All'}>All</MenuItem>
                                  <MenuItem value={'UPS Next Day Air Early'}>
                                    UPS Next Day Air Early
                                  </MenuItem>
                                  <MenuItem value={'UPS Next Day Air'}>
                                    UPS Next Day Air
                                  </MenuItem>
                                  <MenuItem value={'UPS Ground'}>
                                    UPS Ground
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          ) : (
                            configuredCarrierName === 'FedEx' && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={ratesType === 'Guaranteed' ? 3 : 4}
                                lg={ratesType === 'Guaranteed' ? 3 : 4}
                                xl={ratesType === 'Guaranteed' ? 3 : 4}
                              >
                                <FormControl fullWidth>
                                  <InputLabel>Select Service Type </InputLabel>
                                  <Select
                                    disabled={!checkCarrierPermissions()}
                                    label='Select Shipment Type  '
                                    fullWidth
                                    size='small'
                                    labelId='demo-simple-select-label'
                                    id='demo-simple-select'
                                    value={LTLServiceType}
                                    onChange={e => {
                                      setLTLServiceType(e.target.value);
                                    }}
                                  >
                                    <MenuItem value={'All'}>All</MenuItem>
                                    <MenuItem value={'Economy'}>
                                      Economy
                                    </MenuItem>
                                    <MenuItem value={'Priority'}>
                                      Priority
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            )
                          )}
                          <Grid
                            item
                            xs={rateQuoteUIhandler(ratesType, 'xs')}
                            sm={rateQuoteUIhandler(ratesType, 'sm')}
                            md={rateQuoteUIhandler(ratesType, 'md')}
                            lg={rateQuoteUIhandler(ratesType, 'lg')}
                            xl={rateQuoteUIhandler(ratesType, 'xl')}
                          >
                            <FormControl fullWidth>
                              <InputLabel>Select Rates Type </InputLabel>
                              <Select
                                disabled={!checkCarrierPermissions()}
                                label='Select Rates Type  '
                                fullWidth
                                size='small'
                                labelId='demo-simple-select-label'
                                id='demo-simple-select'
                                value={ratesType}
                                onChange={e => {
                                  setGuaranteedType('All');
                                  setRatesType(e.target.value);
                                }}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'Standard'}>Standard</MenuItem>
                                <MenuItem value={'Guaranteed'}>
                                  Guaranteed
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          {ratesType === 'Guaranteed' && (
                            <Grid
                              item
                              xs={rateQuoteUIhandler(ratesType, 'xs')}
                              sm={rateQuoteUIhandler(ratesType, 'sm')}
                              md={rateQuoteUIhandler(ratesType, 'md')}
                              lg={rateQuoteUIhandler(ratesType, 'lg')}
                              xl={rateQuoteUIhandler(ratesType, 'xl')}
                            >
                              <FormControl fullWidth>
                                <InputLabel>Select Guaranteed Type </InputLabel>
                                <Select
                                  disabled={!checkCarrierPermissions()}
                                  label='Select Guaranteed Type  '
                                  fullWidth
                                  size='small'
                                  labelId='demo-simple-select-label'
                                  id='demo-simple-select'
                                  value={guaranteedType}
                                  onChange={e =>
                                    setGuaranteedType(e.target.value)
                                  }
                                >
                                  <MenuItem value={'All'}>All</MenuItem>
                                  <MenuItem value={'Quickest'}>
                                    Quickest Delivery
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>
                      )}
                      {paymentTerms !== 'Both' && (
                        <Grid sx={{ mt: 1 }} container spacing={1}>
                          <Grid
                            item
                            xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                            sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                            md={rateQuoteUIhandler(secondRatesType, 'md')}
                            lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                            xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                          >
                            <FormControl fullWidth>
                              <InputLabel>Select Shipment Type </InputLabel>
                              <Select
                                disabled={!checkCarrierPermissions()}
                                label='Select Shipment Type '
                                fullWidth
                                size='small'
                                labelId='demo-simple-select-label'
                                id='demo-simple-select'
                                value={secondPaymentTerms}
                                onChange={e => {
                                  setSecondPaymentTerms(e.target.value);
                                  e.target.value === 'Inbound'
                                    ? setPaymentTerms('OutBound')
                                    : setPaymentTerms('Inbound');
                                }}
                              >
                                <MenuItem value={'OutBound'}>OutBound</MenuItem>
                                <MenuItem value={'Inbound'}>Inbound</MenuItem>
                                <MenuItem value={'Both'}>Both</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          {selectedTab.current == '3' &&
                          configuredCarrierName === 'UPS' ? (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={secondRatesType === 'Guaranteed' ? 3 : 4}
                              lg={secondRatesType === 'Guaranteed' ? 3 : 4}
                              xl={secondRatesType === 'Guaranteed' ? 3 : 4}
                            >
                              <FormControl fullWidth>
                                <InputLabel>Select Service Type </InputLabel>
                                <Select
                                  disabled={!checkCarrierPermissions()}
                                  label='Select Shipment Type  '
                                  fullWidth
                                  size='small'
                                  labelId='demo-simple-select-label'
                                  id='demo-simple-select'
                                  value={secondParcelServiceType}
                                  onChange={e => {
                                    setSecondParcelServiceType(e.target.value);
                                  }}
                                >
                                  <MenuItem value={'All'}>All</MenuItem>
                                  <MenuItem value={'UPS Next Day Air Early'}>
                                    UPS Next Day Air Early
                                  </MenuItem>
                                  <MenuItem value={'UPS Next Day Air'}>
                                    UPS Next Day Air
                                  </MenuItem>
                                  <MenuItem value={'UPS Ground'}>
                                    UPS Ground
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          ) : (
                            configuredCarrierName === 'FedEx' && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={secondRatesType === 'Guaranteed' ? 3 : 4}
                                lg={secondRatesType === 'Guaranteed' ? 3 : 4}
                                xl={secondRatesType === 'Guaranteed' ? 3 : 4}
                              >
                                <FormControl fullWidth>
                                  <InputLabel>Select Service Type </InputLabel>
                                  <Select
                                    disabled={!checkCarrierPermissions()}
                                    label='Select Shipment Type  '
                                    fullWidth
                                    size='small'
                                    labelId='demo-simple-select-label'
                                    id='demo-simple-select'
                                    value={secondLTLServiceType}
                                    onChange={e => {
                                      setSecondLTLServiceType(e.target.value);
                                    }}
                                  >
                                    <MenuItem value={'All'}>All</MenuItem>
                                    <MenuItem value={'Economy'}>
                                      Economy
                                    </MenuItem>
                                    <MenuItem value={'Priority'}>
                                      Priority
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            )
                          )}
                          <Grid
                            item
                            xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                            sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                            md={rateQuoteUIhandler(secondRatesType, 'md')}
                            lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                            xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                          >
                            <FormControl fullWidth>
                              <InputLabel>Select Rates Type </InputLabel>
                              <Select
                                disabled={!checkCarrierPermissions()}
                                label='Select Rates Type  '
                                fullWidth
                                size='small'
                                labelId='demo-simple-select-label'
                                id='demo-simple-select'
                                value={secondRatesType}
                                onChange={e => {
                                  setSecondGuaranteedType('All');
                                  setSecondRatesType(e.target.value);
                                }}
                              >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'Standard'}>Standard</MenuItem>
                                <MenuItem value={'Guaranteed'}>
                                  Guaranteed
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          {secondRatesType === 'Guaranteed' && (
                            <Grid
                              item
                              xs={rateQuoteUIhandler(secondRatesType, 'xs')}
                              sm={rateQuoteUIhandler(secondRatesType, 'sm')}
                              md={rateQuoteUIhandler(secondRatesType, 'md')}
                              lg={rateQuoteUIhandler(secondRatesType, 'lg')}
                              xl={rateQuoteUIhandler(secondRatesType, 'xl')}
                            >
                              <FormControl fullWidth>
                                <InputLabel>Select Guaranteed Type </InputLabel>
                                <Select
                                  disabled={!checkCarrierPermissions()}
                                  label='Select Guaranteed Type  '
                                  fullWidth
                                  size='small'
                                  labelId='demo-simple-select-label'
                                  id='demo-simple-select'
                                  value={secondGuaranteedType}
                                  onChange={e =>
                                    setSecondGuaranteedType(e.target.value)
                                  }
                                >
                                  <MenuItem value={'All'}>All</MenuItem>
                                  <MenuItem value={'Quickest'}>
                                    Quickest Delivery
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>
                      )}
                    </TabPanel>

                    <TabPanel value='5'>
                      <Grid sx={{ mt: 0 }} container spacing={0}>
                        <Grid item xs={9}>
                          <TextField
                            disabled={!checkCarrierPermissions()}
                            type='number'
                            fullWidth
                            label='Enter Threshold Value'
                            size='small'
                            value={thresholdValue}
                            onChange={e => setThresholdValue(e.target.value)}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel>Type </InputLabel>
                            <Select
                              disabled={!checkCarrierPermissions()}
                              label='Type '
                              fullWidth
                              size='small'
                              labelId='demo-simple-select-label'
                              id='demo-simple-select'
                              value={thresholdType}
                              onChange={e => setThresholdType(e.target.value)}
                            >
                              <MenuItem value={'$'}>$</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </TabPanel>

                    <TabPanel value={'6'}>
                      <Box p={0}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              size='small'
                              label='Contact Name'
                              value={claimSettingsObj.contactName}
                              onChange={e => {
                                handleClaimSettingsChange(
                                  'contactName',
                                  e.target.value
                                );
                                setErrors(prev => ({
                                  ...prev,
                                  contactName: ''
                                }));
                              }}
                              error={!!errors.contactName}
                              helperText={errors.contactName}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              size='small'
                              label='Contact Email'
                              value={claimSettingsObj.contactEmail}
                              onChange={e =>
                                handleClaimSettingsChange(
                                  'contactEmail',
                                  e.target.value
                                )
                              }
                              error={!!errors.contactEmail}
                              helperText={errors.contactEmail}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              inputProps={{ maxLength: 14 }}
                              size='small'
                              label='Contact Phone'
                              value={formatPhoneNumber(
                                claimSettingsObj.contactPhone
                              )}
                              onChange={e =>
                                handleClaimSettingsChange(
                                  'contactPhone',
                                  formatPhoneNumber(e.target.value)
                                )
                              }
                              error={!!errors.contactPhone}
                              helperText={errors.contactPhone}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              fullWidth
                              size='small'
                              label='Copy To (CC)'
                              value={claimSettingsObj.copyTo}
                              onChange={e =>
                                handleClaimSettingsChange(
                                  'copyTo',
                                  e.target.value
                                )
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </TabPanel>
                  </TabContext>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button size='small' variant='outlined' onClick={handleClose}>
              Cancel
            </Button>
            <Button
              disabled={!checkCarrierPermissionsLevel4()}
              size='small'
              variant='contained'
              color='success'
              onClick={
                carrierTabValue === '1'
                  ? handleConfirmationCarrierSettins
                  : carrierTabValue === '2'
                    ? handleThirdPartyRequest
                    : carrierTabValue === '3'
                      ? handleSurchargeRequest
                      : carrierTabValue === '5'
                        ? handleInvoiceThreshold
                        : carrierTabValue === '6'
                          ? handleClaimSettingsRequest
                          : handleRateQuoteSettingsReq
              }
              autoFocus
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          PaperProps={{
            style: {
              minWidth: '28vw',
              height: 'auto'
            }
          }}
          className='InnerDialog'
          open={openConfirmDialogImport}
          onClose={handleConfirmDialogCloseImport}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Confirmation Dialog</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Are you sure to import {eproSeriesDataGenerate?.length} numbers
                of E-Pro Series?
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              onClick={handleConfirmDialogCloseImport}
            >
              No
            </Button>
            <Button
              size='small'
              variant='contained'
              color='success'
              onClick={handleImportEProSeries}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          PaperProps={{
            style: {
              minWidth: '28vw',
              height: '47vh'
            }
          }}
          className='InnerDialog'
          open={openConfirmDialog}
          onClose={handleConfirmDialogClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>Confirmation Dialog</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <Grid sx={{ display: 'flex', justifyContent: 'space-around' }}>
                Changes are un-revertible until it reached to the minimum Alert
                Level
              </Grid>
              <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid sx={{ mt: 1 }} container spacing={0}>
                    <Grid item xs={6}>
                      <InputLabel sx={{ mb: 1, fontSize: 14 }}>
                        Pro Number
                      </InputLabel>

                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{
                          disableUnderline: true
                        }}
                        variant='standard'
                        required
                        error={Boolean(proNumberErrors['proNumberFrom'])}
                        helperText={proNumberErrors['proNumberFrom']}
                        FormHelperTextProps={{ style: { margin: ' 5 0 0 0' } }}
                        // type='number'
                        fullWidth
                        label='From'
                        size='small'
                        value={
                          proNumberSuffixPosition === 'Pre'
                            ? proNumberSuffixValue + proNumberFrom
                            : proNumberFrom + proNumberSuffixValue
                        }
                        onChange={e => {
                          setProNumbersErrors({
                            ...proNumberErrors,
                            proNumberFrom: null
                          });
                          setProNumberFrom(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{
                          disableUnderline: true
                        }}
                        variant='standard'
                        required
                        error={Boolean(proNumberErrors['proNumberTo'])}
                        helperText={proNumberErrors['proNumberTo']}
                        FormHelperTextProps={{ style: { margin: ' 5 0 0 0' } }}
                        sx={{ mt: 3.2 }}
                        // type='number'
                        fullWidth
                        label='To'
                        size='small'
                        value={
                          proNumberSuffixPosition === 'Pre'
                            ? proNumberSuffixValue + proNumberTo
                            : proNumberTo + proNumberSuffixValue
                        }
                        onChange={e => {
                          setProNumbersErrors({
                            ...proNumberErrors,
                            proNumberTo: null
                          });
                          setProNumberTo(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid sx={{ mt: 0 }} container spacing={1}>
                    <Grid item xs={12}>
                      <TextField
                        InputLabelProps={{
                          style: { color: 'black', fontSize: 18 }
                        }}
                        disabled
                        InputProps={{
                          disableUnderline: true
                        }}
                        variant='standard'
                        required
                        error={Boolean(proNumberErrors['proNumberAlert'])}
                        helperText={proNumberErrors['proNumberAlert']}
                        FormHelperTextProps={{ style: { margin: ' 5 0 0 0' } }}
                        inputProps={{ min: 1, max: proNumberTo }}
                        // type='number'
                        fullWidth
                        label='minimum pro-number for Alert'
                        size='small'
                        value={proNumberAlert}
                        onChange={e => {
                          setProNumbersErrors({
                            ...proNumberErrors,
                            proNumberAlert: null
                          });
                          setProNumberAlert(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                  {proNumberTo && (
                    <Grid sx={{ mt: 0 }} container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          InputLabelProps={{
                            style: { color: 'black', fontSize: 18 }
                          }}
                          disabled
                          InputProps={{
                            disableUnderline: true
                          }}
                          variant='standard'
                          // type='number'
                          fullWidth
                          label='Total Pro-Numbers'
                          size='small'
                          value={
                            !proNmbChanged && proNumberTotals
                              ? proNumberTotals
                              : handleRemainingPro()
                          }
                          // onChange={handleTextFieldChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          InputLabelProps={{
                            style: { color: 'black', fontSize: 18 }
                          }}
                          disabled
                          InputProps={{
                            disableUnderline: true
                          }}
                          variant='standard'
                          // type='number'
                          fullWidth
                          label='Remaining Pro-Numbers'
                          size='small'
                          value={
                            !proNmbChanged && proNumberLeft !== null
                              ? proNumberLeft
                              : handleRemainingPro()
                          }
                          // onChange={handleTextFieldChange}
                        />
                      </Grid>
                    </Grid>
                  )}
                  {email && (
                    <TextField
                      InputLabelProps={{
                        style: { color: 'black', fontSize: 18 }
                      }}
                      disabled
                      InputProps={{
                        disableUnderline: true
                      }}
                      variant='standard'
                      fullWidth
                      label='Emails for Alert'
                      size='small'
                      multiline // Enables multiline rendering
                      value={
                        email.length > 40 || email.split(',').length > 3
                          ? email.split(',').join('\n') // Use new lines if conditions match
                          : email
                      } // Otherwise, keep as is
                    />
                  )}
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'
              variant='outlined'
              onClick={handleConfirmDialogClose}
            >
              No
            </Button>
            <Button
              size='small'
              variant='contained'
              color='success'
              onClick={handleUpdateCarrierRequest}
              autoFocus
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
      <Grid container sx={{ m: 0 }}>
        {carriersLoader ? (
          <CircularProgress />
        ) : isNewUI ? (
          <Grid
            container
            spacing={2}
            sx={{
              height: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 125px)' },
              minHeight: '100%'
            }}
          >
            {/* Left Sidebar */}
            <Grid
              container
              spacing={2}
              sx={{
                height: {
                  xs: 'calc(100vh - 100px)',
                  md: 'calc(100vh - 125px)'
                },
                minHeight: '100%'
              }}
            >
              {/* Left Sidebar - Conditionally render based on selectedCarrier */}
              {!listView && (
                <Grid item md={3.5} lg={3.5} xl={3.5}>
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    {/* Tabs Header */}
                    <Tabs
                      value={selectedTab.current}
                      onChange={handleTabChange}
                      variant='fullWidth'
                      textColor='primary'
                      indicatorColor='primary'
                      sx={{
                        minHeight: 36,
                        '& .MuiTab-root': {
                          textTransform: 'none',
                          fontWeight: 500,
                          fontSize: '0.75rem',
                          minHeight: 36,
                          padding: '6px 12px',
                          minWidth: 'auto'
                        }
                      }}
                    >
                      <Tab value={1} label='LTL' />
                      <Tab value={2} label='TL' />
                      <Tab value={3} label='Parcel' />
                    </Tabs>

                    <Box sx={{ mt: 2 }}>
                      <TextField
                        fullWidth
                        placeholder='Search...'
                        size='small'
                        variant='outlined'
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        InputProps={{
                          endAdornment: searchTerm && (
                            <InputAdornment position='end'>
                              <IconButton
                                size='small'
                                onClick={() => setSearchTerm('')}
                              >
                                <ClearIcon fontSize='small' />
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                      />
                    </Box>

                    <Box sx={{ mx: 1, my: 1 }}>
                      <Box
                        display='flex'
                        alignItems='center'
                        justifyContent='space-between'
                      >
                        <Typography variant='subtitle2' fontWeight='bold'>
                          Sort:
                        </Typography>

                        <Box display='flex' alignItems='center' gap={0.5}>
                          {[
                            { key: 'name', label: 'Name', icon: <SortIcon /> },
                            {
                              key: 'total',
                              label: 'Total',
                              icon: (
                                <NumbersIcon
                                  sx={{
                                    fontSize: '1rem',
                                    color: '#1976d2'
                                  }}
                                />
                              )
                            },
                            {
                              key: 'consumed',
                              label: 'Consumed',
                              icon: (
                                <RemoveCircleOutlineIcon
                                  sx={{
                                    fontSize: '1rem',
                                    color: '#f44336'
                                  }}
                                />
                              )
                            },

                            {
                              key: 'remaining',
                              label: 'Remaining',
                              icon: (
                                <CheckCircleOutlineIcon
                                  sx={{
                                    fontSize: '1rem',
                                    color: '#4caf50'
                                  }}
                                />
                              )
                            },
                            {
                              key: 'surcharge',
                              label: 'Surcharge',
                              icon: <AttachMoneyIcon fontSize='small' />
                            }
                          ]
                            .filter(item => {
                              // Show all sort options EXCEPT when it's specifically TL carriers
                              if (selectedTab.current == '2') {
                                return item.key === 'name'; // Only name sorting for TL
                              }
                              return true; // All sorting for non-TL (LTL, Parcel, etc.)
                            })
                            .map(item => (
                              <Tooltip
                                key={item.key}
                                title={`Sort by ${item.label}`}
                              >
                                <IconButton
                                  size='small'
                                  onClick={() => handleSort(item.key)}
                                  color={
                                    sortBy === item.key ? 'primary' : 'default'
                                  }
                                  sx={{
                                    border:
                                      sortBy === item.key
                                        ? '1px solid'
                                        : 'none',
                                    borderColor: 'primary.main'
                                  }}
                                >
                                  {item.icon}
                                </IconButton>
                              </Tooltip>
                            ))}

                          {/* Order Toggle */}
                          {sortBy && (
                            <Tooltip
                              title={
                                sortOrder === 'asc' ? 'Descending' : 'Ascending'
                              }
                            >
                              <IconButton
                                size='small'
                                onClick={() =>
                                  setSortOrder(
                                    sortOrder === 'asc' ? 'desc' : 'asc'
                                  )
                                }
                                color='primary'
                              >
                                {sortOrder === 'asc' ? (
                                  <ArrowUpwardIcon fontSize='small' />
                                ) : (
                                  <ArrowDownwardIcon fontSize='small' />
                                )}
                              </IconButton>
                            </Tooltip>
                          )}
                        </Box>
                      </Box>
                    </Box>

                    <Grid sx={{ maxHeight: '80%', overflow: 'auto', p: 1 }}>
                      {filteredCarriers.map((items, index) => (
                        <CarrierCard
                          key={index}
                          items={items}
                          selected={selectedCarrier.current.id === items.id}
                          onSelect={() => {
                            setListView(false);
                            handleUpdateCarrier('', items, 'kanbanView');
                            forceUpdate();
                            selectedCarrier.current = items;
                          }}
                          selectedTab={selectedTab.current}
                        />
                      ))}
                    </Grid>

                    <Box sx={{ flexGrow: 1 }} />
                  </Card>
                </Grid>
              )}

              {/* Right Content - Adjust width based on selectedCarrier */}
              <Grid
                item
                md={!listView ? 8.5 : 12}
                lg={!listView ? 8.5 : 12}
                xl={!listView ? 8.5 : 12}
              >
                {!listView ? (
                  // Show carrier details when a carrier is selected
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'end'
                    }}
                  >
                    {selectedTab.current == '2' ? (
                      <Box
                        sx={{
                          pt: 1,
                          overflow: 'auto',
                          height: {
                            xs: 'calc(100vh - 100px)',
                            md: 'calc(100vh - 165px)'
                          },
                          minHeight: '100%'
                        }}
                      >
                        <CreateCarrier
                          key={selectedCarrier.current.id}
                          state={selectedCarrier.current}
                          action={'NewUI'}
                          fetchCarriers={fetchCarriers}
                          handleCloseTLView={handleBackToList}
                        />
                      </Box>
                    ) : (
                      <CardContent
                        sx={{
                          height: {
                            xs: 'calc(100vh - 100px)',
                            md: 'calc(100vh - 165px)'
                          },
                          minHeight: '100%'
                        }}
                      >
                        <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                          <TabContext value={carrierTabValue}>
                            <TabList
                              variant='scrollable'
                              // scrollButtons='auto'
                              scrollButtons={true}
                              allowScrollButtonsMobile
                              onChange={handleCarrierTabChange}
                              aria-label='carrier settings tabs'
                              sx={{
                                minHeight: 36,
                                '& .MuiTab-root': {
                                  textTransform: 'none',
                                  fontWeight: 500,
                                  fontSize: '0.75rem',
                                  minHeight: 36,
                                  padding: '6px 12px',
                                  minWidth: 'auto'
                                }
                              }}
                            >
                              <Tab
                                disabled={!isEProSeriesGenerate}
                                label='Pro Number Settings'
                                value='1'
                              />
                              <Tab label='Third Party Settings' value='2' />
                              <Tab label='Surcharge Settings' value='3' />
                              <Tab label='Rate Quote Settings' value='4' />
                              <Tab label='Threshold Settings' value='5' />
                              <Tab label='Claim Settings' value='6' />
                            </TabList>

                            <TabPanel value='1'>
                              <Grid sx={{ mt: 0 }} container spacing={0}>
                                <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                  <FormControl fullWidth>
                                    <InputLabel>Suffix </InputLabel>
                                    <Select
                                      // disabled={
                                      //   ((userPermissionsArr &&
                                      //     ((userPermissionsArr.filter(
                                      //       permissions => permissions.level3
                                      //     ).length &&
                                      //       !pronmbsApiData) ||
                                      //       (userPermissionsArr.filter(
                                      //         permissions => permissions.level4
                                      //       ).length &&
                                      //         pronmbsApiData))) ||
                                      //     UserIsAdmin) &&
                                      //     pronmbsApiData &&
                                      //     pronmbsApiData.proNumberAlertOn >=
                                      //     pronmbsApiData.proNumberLeft
                                      //     ? false
                                      //     : true
                                      // }
                                      disabled={
                                        (userPermissionsArr &&
                                          (userPermissionsArr.filter(
                                            permissions => permissions.level3
                                          ).length ||
                                            userPermissionsArr.filter(
                                              permissions => permissions.level4
                                            ).length)) ||
                                        UserIsAdmin
                                          ? false
                                          : true
                                      }
                                      label='Suffix '
                                      fullWidth
                                      size='small'
                                      labelId='demo-simple-select-label'
                                      id='demo-simple-select'
                                      value={proNumberSuffixPosition}
                                      onChange={handleChangeProNmb}
                                    >
                                      <MenuItem value={'Pre'}>Pre</MenuItem>
                                      <MenuItem value={'Post'}>Post</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid
                                  item
                                  sx={{
                                    mt: {
                                      xs: 1,
                                      sm: 0,
                                      md: 0,
                                      lg: 0,
                                      xl: 0
                                    }
                                  }}
                                  xs={12}
                                  sm={12}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                >
                                  <TextField
                                    // disabled={
                                    //   ((userPermissionsArr &&
                                    //     ((userPermissionsArr.filter(
                                    //       permissions => permissions.level3
                                    //     ).length &&
                                    //       !pronmbsApiData) ||
                                    //       (userPermissionsArr.filter(
                                    //         permissions => permissions.level4
                                    //       ).length &&
                                    //         pronmbsApiData))) ||
                                    //     UserIsAdmin) &&
                                    //     pronmbsApiData &&
                                    //     pronmbsApiData.proNumberAlertOn >=
                                    //     pronmbsApiData.proNumberLeft
                                    //     ? false
                                    //     : true
                                    // }
                                    disabled={
                                      (userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                      UserIsAdmin
                                        ? false
                                        : true
                                    }
                                    error={Boolean(
                                      proNumberErrors['proNumberSuffixValue']
                                    )}
                                    helperText={
                                      proNumberErrors['proNumberSuffixValue']
                                    }
                                    type='text'
                                    fullWidth
                                    label={`Enter ${proNumberSuffixPosition}`}
                                    size='small'
                                    value={proNumberSuffixValue}
                                    onChange={e => {
                                      setProNumberSuffixValue(e.target.value);
                                      setProNumbersErrors({
                                        ...proNumberErrors,
                                        proNumberSuffixValue: null
                                      });
                                    }}
                                  />
                                </Grid>
                              </Grid>
                              <Grid sx={{ mt: 2 }} container spacing={0}>
                                <Grid item xs={6}>
                                  <InputLabel sx={{ mb: 1, fontSize: 12 }}>
                                    Enter Pro Number
                                  </InputLabel>

                                  <TextField
                                    // disabled={
                                    //   ((userPermissionsArr &&
                                    //     ((userPermissionsArr.filter(
                                    //       permissions => permissions.level3
                                    //     ).length &&
                                    //       !pronmbsApiData) ||
                                    //       (userPermissionsArr.filter(
                                    //         permissions => permissions.level4
                                    //       ).length &&
                                    //         pronmbsApiData))) ||
                                    //     UserIsAdmin) &&
                                    //     pronmbsApiData &&
                                    //     pronmbsApiData.proNumberAlertOn >=
                                    //     pronmbsApiData.proNumberLeft
                                    //     ? false
                                    //     : true
                                    // }
                                    disabled={
                                      (userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                      UserIsAdmin
                                        ? false
                                        : true
                                    }
                                    required
                                    inputProps={{ min: 0 }}
                                    error={Boolean(
                                      proNumberErrors['proNumberFrom']
                                    )}
                                    helperText={
                                      proNumberErrors['proNumberFrom']
                                    }
                                    FormHelperTextProps={{
                                      style: { margin: ' 5 0 0 0' }
                                    }}
                                    // type='number'
                                    fullWidth
                                    label='From'
                                    size='small'
                                    value={proNumberFrom}
                                    onChange={e => handleProNumberFromChange(e)}
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    // disabled={
                                    //   ((userPermissionsArr &&
                                    //     ((userPermissionsArr.filter(
                                    //       permissions => permissions.level3
                                    //     ).length &&
                                    //       !pronmbsApiData) ||
                                    //       (userPermissionsArr.filter(
                                    //         permissions => permissions.level4
                                    //       ).length &&
                                    //         pronmbsApiData))) ||
                                    //     UserIsAdmin) &&
                                    //     pronmbsApiData &&
                                    //     pronmbsApiData.proNumberAlertOn >=
                                    //     pronmbsApiData.proNumberLeft
                                    //     ? false
                                    //     : true
                                    // }
                                    disabled={
                                      (userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                      UserIsAdmin
                                        ? false
                                        : true
                                    }
                                    inputProps={{ min: proNumberFrom }}
                                    required
                                    error={Boolean(
                                      proNumberErrors['proNumberTo']
                                    )}
                                    helperText={proNumberErrors['proNumberTo']}
                                    FormHelperTextProps={{
                                      style: { margin: ' 5 0 0 0' }
                                    }}
                                    sx={{ mt: 3.2 }}
                                    // type='number'
                                    fullWidth
                                    label='To'
                                    size='small'
                                    value={proNumberTo}
                                    onChange={e => handleProNumberToChange(e)}
                                  />
                                </Grid>
                              </Grid>
                              <Grid sx={{ mt: 2 }} container spacing={1}>
                                <Grid item xs={6} sm={6}>
                                  <TextField
                                    disabled={
                                      (userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                      UserIsAdmin
                                        ? false
                                        : true
                                    }
                                    required
                                    error={Boolean(
                                      proNumberErrors['proNumberAlert']
                                    )}
                                    helperText={
                                      proNumberErrors['proNumberAlert']
                                    }
                                    FormHelperTextProps={{
                                      style: { margin: ' 5 0 0 0' }
                                    }}
                                    inputProps={{
                                      min: 1,
                                      max: proNumberTo
                                    }}
                                    // type='number'
                                    fullWidth
                                    label='Enter minimum pro-number for Alert'
                                    size='small'
                                    value={proNumberAlert}
                                    onChange={e =>
                                      handleProNumberAlertChange(e)
                                    }
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  sm={6}
                                  className='d-flex justify-content-end'
                                >
                                  <Button
                                    size='small'
                                    variant='contained'
                                    className=''
                                    onClick={handleGenerateEProSeriesDialog}
                                    disabled={
                                      (userPermissionsArr &&
                                        (userPermissionsArr.filter(
                                          permissions => permissions.level3
                                        ).length ||
                                          userPermissionsArr.filter(
                                            permissions => permissions.level4
                                          ).length)) ||
                                      UserIsAdmin
                                        ? false
                                        : true
                                    }
                                  >
                                    Generate E-Pro Series
                                  </Button>
                                </Grid>
                              </Grid>
                              {proNumberTo && (
                                <Grid sx={{ mt: 2 }} container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      InputLabelProps={{
                                        style: { color: 'black' }
                                      }}
                                      disabled
                                      InputProps={{
                                        disableUnderline: true
                                      }}
                                      variant='standard'
                                      // type='number'
                                      fullWidth
                                      label='Total Pro-Numbers'
                                      size='small'
                                      value={
                                        !proNmbChanged && proNumberTotals
                                          ? proNumberTotals
                                          : handleRemainingPro()
                                      }
                                      // onChange={handleTextFieldChange}
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      InputLabelProps={{
                                        style: { color: 'black' }
                                      }}
                                      disabled
                                      InputProps={{
                                        disableUnderline: true
                                      }}
                                      variant='standard'
                                      // type='number'
                                      fullWidth
                                      label='Remaining Pro-Numbers'
                                      size='small'
                                      value={
                                        !proNmbChanged && proNumberLeft !== null
                                          ? proNumberLeft
                                          : handleRemainingPro()
                                      }
                                      // onChange={handleTextFieldChange}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <TextField
                                  fullWidth
                                  // disabled={
                                  //   (userPermissionsArr &&
                                  //     ((userPermissionsArr.filter(
                                  //       permissions => permissions.level3
                                  //     ).length &&
                                  //       !EditedData) ||
                                  //       (userPermissionsArr.filter(
                                  //         permissions => permissions.level4
                                  //       ).length &&
                                  //         EditedData))) ||
                                  //   UserIsAdmin
                                  //     ? false
                                  //     : true
                                  // }
                                  // variant='standard'
                                  FormHelperTextProps={{
                                    style: { margin: ' 5 30 0 0' }
                                  }}
                                  error={Boolean(
                                    validationErrors['emailError']
                                  )}
                                  helperText={
                                    validationErrors.emailError ||
                                    (email &&
                                      'To add multiple email addresses, please separate each address with a comma')
                                  }
                                  onChange={e =>
                                    handleEmailValidation(e.target.value)
                                  }
                                  value={email}
                                  required
                                  // InputLabelProps={{ style: { fontSize: 13 } }}
                                  inputProps={{ style: { fontSize: 13 } }}
                                  sx={{ mt: 3 }}
                                  size='small'
                                  label='Enter Email Address For Alert'
                                  type='email'
                                />
                              </Grid>

                              <Button
                                size='small'
                                variant='contained'
                                className='mt-3'
                                onClick={handleOpenEProSeriesDialog}
                              >
                                Show E-Pro Series
                              </Button>
                            </TabPanel>
                            <TabPanel value='2'>
                              <TextField
                                disabled={
                                  !UserIsAdmin &&
                                  !(
                                    userPermissionsArr &&
                                    userPermissionsArr.filter(
                                      permissions => permissions.level4
                                    ).length
                                  )
                                    ? true
                                    : false
                                }
                                value={
                                  thirdPatyAccDetails.thirdPartyAccountNumber
                                }
                                fullWidth
                                sx={{ mt: 1 }}
                                label='Enter Third Party Account'
                                size='small'
                                onChange={e =>
                                  setThirdPatyAccDetails({
                                    ...thirdPatyAccDetails,
                                    thirdPartyAccountNumber: e.target.value
                                  })
                                }
                              />
                              <TextField
                                disabled={
                                  !UserIsAdmin &&
                                  !(
                                    userPermissionsArr &&
                                    userPermissionsArr.filter(
                                      permissions => permissions.level4
                                    ).length
                                  )
                                    ? true
                                    : false
                                }
                                value={thirdPatyAccDetails.companyName}
                                fullWidth
                                sx={{ mt: 2 }}
                                label='Company Name'
                                size='small'
                                onChange={e =>
                                  setThirdPatyAccDetails({
                                    ...thirdPatyAccDetails,
                                    companyName: e.target.value
                                  })
                                }
                                // onChange={e => setThirdPatyAccNmb(e.target.value)}
                              />
                              <TextField
                                disabled={
                                  !UserIsAdmin &&
                                  !(
                                    userPermissionsArr &&
                                    userPermissionsArr.filter(
                                      permissions => permissions.level4
                                    ).length
                                  )
                                    ? true
                                    : false
                                }
                                value={thirdPatyAccDetails.streetLines}
                                fullWidth
                                sx={{ mt: 2 }}
                                label='Address'
                                size='small'
                                onChange={e =>
                                  setThirdPatyAccDetails({
                                    ...thirdPatyAccDetails,
                                    streetLines: e.target.value
                                  })
                                }
                                // onChange={e => setThirdPatyAccNmb(e.target.value)}
                              />

                              <Grid container sx={{ display: 'flex' }}>
                                <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <TextField
                                    disabled={
                                      !UserIsAdmin &&
                                      !(
                                        userPermissionsArr &&
                                        userPermissionsArr.filter(
                                          permissions => permissions.level4
                                        ).length
                                      )
                                        ? true
                                        : false
                                    }
                                    value={thirdPatyAccDetails.phoneNumber}
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    label='Phone Number'
                                    size='small'
                                    error={Boolean(
                                      validationErrors['phoneNumberErrorBT']
                                    )}
                                    helperText={
                                      validationErrors['phoneNumberErrorBT']
                                    }
                                    onChange={event =>
                                      ValidatePhoneNumber(event.target.value)
                                    }
                                  />
                                </Grid>
                                <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <TextField
                                    disabled={
                                      !UserIsAdmin &&
                                      !(
                                        userPermissionsArr &&
                                        userPermissionsArr.filter(
                                          permissions => permissions.level4
                                        ).length
                                      )
                                        ? true
                                        : false
                                    }
                                    value={thirdPatyAccDetails.emailAddress}
                                    fullWidth
                                    sx={{ mt: 2 }}
                                    label='Email'
                                    size='small'
                                    type='email'
                                    error={Boolean(
                                      validationErrors['emailErrorBT']
                                    )}
                                    helperText={
                                      validationErrors['emailErrorBT']
                                    }
                                    onChange={e =>
                                      ValidateEmailAddress(e.target.value)
                                    }
                                  />
                                </Grid>
                              </Grid>

                              <Grid sx={{ display: 'flex' }}>
                                <TextField
                                  disabled={
                                    !UserIsAdmin &&
                                    !(
                                      userPermissionsArr &&
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length
                                    )
                                      ? true
                                      : false
                                  }
                                  value={thirdPatyAccDetails.city}
                                  fullWidth
                                  sx={{ mt: 2 }}
                                  label='City'
                                  size='small'
                                  onChange={e =>
                                    setThirdPatyAccDetails({
                                      ...thirdPatyAccDetails,
                                      city: e.target.value
                                    })
                                  }
                                  // onChange={e => setThirdPatyAccNmb(e.target.value)}
                                />
                                <TextField
                                  disabled={
                                    !UserIsAdmin &&
                                    !(
                                      userPermissionsArr &&
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length
                                    )
                                      ? true
                                      : false
                                  }
                                  value={thirdPatyAccDetails.state}
                                  fullWidth
                                  sx={{ mt: 2 }}
                                  label='State'
                                  size='small'
                                  onChange={e =>
                                    setThirdPatyAccDetails({
                                      ...thirdPatyAccDetails,
                                      state: e.target.value
                                    })
                                  }
                                  // onChange={e => setThirdPatyAccNmb(e.target.value)}
                                />
                              </Grid>
                              <Grid sx={{ display: 'flex' }}>
                                <TextField
                                  disabled={
                                    !UserIsAdmin &&
                                    !(
                                      userPermissionsArr &&
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length
                                    )
                                      ? true
                                      : false
                                  }
                                  value={thirdPatyAccDetails.postalCode}
                                  fullWidth
                                  sx={{ mt: 2 }}
                                  label='Postal Code'
                                  size='small'
                                  onChange={e =>
                                    setThirdPatyAccDetails({
                                      ...thirdPatyAccDetails,
                                      postalCode: e.target.value
                                    })
                                  }
                                  type='number'
                                  // onChange={e => setThirdPatyAccNmb(e.target.value)}
                                />
                                <TextField
                                  disabled={
                                    !UserIsAdmin &&
                                    !(
                                      userPermissionsArr &&
                                      userPermissionsArr.filter(
                                        permissions => permissions.level4
                                      ).length
                                    )
                                      ? true
                                      : false
                                  }
                                  value={thirdPatyAccDetails.countryCode}
                                  fullWidth
                                  sx={{ mt: 2 }}
                                  label='Country'
                                  size='small'
                                  onChange={e =>
                                    setThirdPatyAccDetails({
                                      ...thirdPatyAccDetails,
                                      countryCode: e.target.value
                                    })
                                  }
                                  // onChange={e => setThirdPatyAccNmb(e.target.value)}
                                />
                              </Grid>
                            </TabPanel>
                            <TabPanel value='3'>
                              <Grid sx={{ mt: 0 }} container spacing={0}>
                                <Grid item xs={9}>
                                  <TextField
                                    // disabled={
                                    //   ((userPermissionsArr &&
                                    //     ((userPermissionsArr.filter(
                                    //       permissions => permissions.level3
                                    //     ).length &&
                                    //       !pronmbsApiData) ||
                                    //       (userPermissionsArr.filter(
                                    //         permissions => permissions.level4
                                    //       ).length &&
                                    //         pronmbsApiData))) ||
                                    //     UserIsAdmin) &&
                                    //   pronmbsApiData &&
                                    //   pronmbsApiData.proNumberAlertOn >=
                                    //     pronmbsApiData.proNumberLeft
                                    //     ? false
                                    //     : true
                                    // }
                                    type='number'
                                    fullWidth
                                    label='Enter Surcharge Value'
                                    size='small'
                                    value={surchargeValue}
                                    onChange={e =>
                                      setSurchargeValue(e.target.value)
                                    }
                                  />
                                </Grid>
                                <Grid item xs={3}>
                                  <FormControl fullWidth>
                                    <InputLabel>Type </InputLabel>
                                    <Select
                                      // disabled={
                                      //   ((userPermissionsArr &&
                                      //     ((userPermissionsArr.filter(
                                      //       permissions => permissions.level3
                                      //     ).length &&
                                      //       !pronmbsApiData) ||
                                      //       (userPermissionsArr.filter(
                                      //         permissions => permissions.level4
                                      //       ).length &&
                                      //         pronmbsApiData))) ||
                                      //     UserIsAdmin) &&
                                      //   pronmbsApiData &&
                                      //   pronmbsApiData.proNumberAlertOn >=
                                      //     pronmbsApiData.proNumberLeft
                                      //     ? false
                                      //     : true
                                      // }
                                      label='Type '
                                      fullWidth
                                      size='small'
                                      labelId='demo-simple-select-label'
                                      id='demo-simple-select'
                                      value={surchargeType}
                                      onChange={e =>
                                        setSurchargeType(e.target.value)
                                      }
                                    >
                                      <MenuItem value={'%'}>%</MenuItem>
                                      <MenuItem value={'$'}>$</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                              <Grid sx={{ mt: 2 }} item xs={12} sm={12}>
                                <Autocomplete
                                  size='small'
                                  multiple
                                  options={surchargeTypeArr} // Options from the array
                                  value={selectedOptions} // Bind the selected options to the state
                                  onChange={handleSurchargeChange} // Handle selection
                                  renderInput={params => (
                                    <TextField
                                      size='small'
                                      {...params}
                                      variant='outlined'
                                      label='Select Surcharge Types'
                                      placeholder='Choose...'
                                    />
                                  )}
                                  renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                      <Chip
                                        key={option}
                                        label={option}
                                        {...getTagProps({ index })}
                                      />
                                    ))
                                  }
                                />
                              </Grid>
                            </TabPanel>
                            <TabPanel value='4'>
                              {secondPaymentTerms !== 'Both' && (
                                <Grid sx={{ mt: 1 }} container spacing={1}>
                                  <Grid
                                    item
                                    // xs={12} sm={6} md={6} lg={6} xl={6}
                                    xs={rateQuoteUIhandler(ratesType, 'xs')}
                                    sm={rateQuoteUIhandler(ratesType, 'sm')}
                                    md={rateQuoteUIhandler(ratesType, 'md')}
                                    lg={rateQuoteUIhandler(ratesType, 'lg')}
                                    xl={rateQuoteUIhandler(ratesType, 'xl')}
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel>
                                        Select Shipment Type{' '}
                                      </InputLabel>
                                      <Select
                                        // disabled={
                                        //   ((userPermissionsArr &&
                                        //     ((userPermissionsArr.filter(
                                        //       permissions => permissions.level3
                                        //     ).length &&
                                        //       !pronmbsApiData) ||
                                        //       (userPermissionsArr.filter(
                                        //         permissions => permissions.level4
                                        //       ).length &&
                                        //         pronmbsApiData))) ||
                                        //     UserIsAdmin) &&
                                        //   pronmbsApiData &&
                                        //   pronmbsApiData.proNumberAlertOn >=
                                        //     pronmbsApiData.proNumberLeft
                                        //     ? false
                                        //     : true
                                        // }
                                        label='Select Shipment Type  '
                                        fullWidth
                                        size='small'
                                        labelId='demo-simple-select-label'
                                        id='demo-simple-select'
                                        value={paymentTerms}
                                        onChange={e => {
                                          setPaymentTerms(e.target.value);
                                          e.target.value === 'Inbound'
                                            ? setSecondPaymentTerms('OutBound')
                                            : setSecondPaymentTerms('Inbound');
                                        }}
                                      >
                                        <MenuItem value={'Inbound'}>
                                          Inbound
                                        </MenuItem>
                                        <MenuItem value={'OutBound'}>
                                          OutBound
                                        </MenuItem>
                                        <MenuItem value={'Both'}>Both</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  {value === '3' &&
                                  configuredCarrierName === 'UPS' ? (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={ratesType === 'Guaranteed' ? 3 : 4}
                                      lg={ratesType === 'Guaranteed' ? 3 : 4}
                                      xl={ratesType === 'Guaranteed' ? 3 : 4}
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel>
                                          Select Service Type{' '}
                                        </InputLabel>
                                        <Select
                                          label='Select Shipment Type  '
                                          fullWidth
                                          size='small'
                                          labelId='demo-simple-select-label'
                                          id='demo-simple-select'
                                          value={parcelServiceType}
                                          onChange={e => {
                                            setParcelServiceType(
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <MenuItem value={'All'}>All</MenuItem>
                                          <MenuItem
                                            value={'UPS Next Day Air Early'}
                                          >
                                            UPS Next Day Air Early
                                          </MenuItem>
                                          <MenuItem value={'UPS Next Day Air'}>
                                            UPS Next Day Air
                                          </MenuItem>
                                          <MenuItem value={'UPS Ground'}>
                                            UPS Ground
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    configuredCarrierName === 'FedEx' && (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={ratesType === 'Guaranteed' ? 3 : 4}
                                        lg={ratesType === 'Guaranteed' ? 3 : 4}
                                        xl={ratesType === 'Guaranteed' ? 3 : 4}
                                      >
                                        <FormControl fullWidth>
                                          <InputLabel>
                                            Select Service Type{' '}
                                          </InputLabel>
                                          <Select
                                            label='Select Shipment Type  '
                                            fullWidth
                                            size='small'
                                            labelId='demo-simple-select-label'
                                            id='demo-simple-select'
                                            value={LTLServiceType}
                                            onChange={e => {
                                              setLTLServiceType(e.target.value);
                                            }}
                                          >
                                            <MenuItem value={'All'}>
                                              All
                                            </MenuItem>
                                            <MenuItem value={'Economy'}>
                                              Economy
                                            </MenuItem>
                                            <MenuItem value={'Priority'}>
                                              Priority
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    )
                                  )}
                                  <Grid
                                    item
                                    xs={rateQuoteUIhandler(ratesType, 'xs')}
                                    sm={rateQuoteUIhandler(ratesType, 'sm')}
                                    md={rateQuoteUIhandler(ratesType, 'md')}
                                    lg={rateQuoteUIhandler(ratesType, 'lg')}
                                    xl={rateQuoteUIhandler(ratesType, 'xl')}
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel>
                                        Select Rates Type{' '}
                                      </InputLabel>
                                      <Select
                                        label='Select Rates Type  '
                                        fullWidth
                                        size='small'
                                        labelId='demo-simple-select-label'
                                        id='demo-simple-select'
                                        value={ratesType}
                                        onChange={e => {
                                          setGuaranteedType('All');
                                          setRatesType(e.target.value);
                                        }}
                                      >
                                        <MenuItem value={'All'}>All</MenuItem>
                                        <MenuItem value={'Standard'}>
                                          Standard
                                        </MenuItem>
                                        <MenuItem value={'Guaranteed'}>
                                          Guaranteed
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  {ratesType === 'Guaranteed' && (
                                    <Grid
                                      item
                                      xs={rateQuoteUIhandler(ratesType, 'xs')}
                                      sm={rateQuoteUIhandler(ratesType, 'sm')}
                                      md={rateQuoteUIhandler(ratesType, 'md')}
                                      lg={rateQuoteUIhandler(ratesType, 'lg')}
                                      xl={rateQuoteUIhandler(ratesType, 'xl')}
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel>
                                          Select Guaranteed Type{' '}
                                        </InputLabel>
                                        <Select
                                          label='Select Guaranteed Type  '
                                          fullWidth
                                          size='small'
                                          labelId='demo-simple-select-label'
                                          id='demo-simple-select'
                                          value={guaranteedType}
                                          onChange={e =>
                                            setGuaranteedType(e.target.value)
                                          }
                                        >
                                          <MenuItem value={'All'}>All</MenuItem>
                                          <MenuItem value={'Quickest'}>
                                            Quickest Delivery
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  )}
                                </Grid>
                              )}
                              {paymentTerms !== 'Both' && (
                                <Grid sx={{ mt: 1 }} container spacing={1}>
                                  <Grid
                                    item
                                    xs={rateQuoteUIhandler(
                                      secondRatesType,
                                      'xs'
                                    )}
                                    sm={rateQuoteUIhandler(
                                      secondRatesType,
                                      'sm'
                                    )}
                                    md={rateQuoteUIhandler(
                                      secondRatesType,
                                      'md'
                                    )}
                                    lg={rateQuoteUIhandler(
                                      secondRatesType,
                                      'lg'
                                    )}
                                    xl={rateQuoteUIhandler(
                                      secondRatesType,
                                      'xl'
                                    )}
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel>
                                        Select Shipment Type{' '}
                                      </InputLabel>
                                      <Select
                                        label='Select Shipment Type '
                                        fullWidth
                                        size='small'
                                        labelId='demo-simple-select-label'
                                        id='demo-simple-select'
                                        value={secondPaymentTerms}
                                        onChange={e => {
                                          setSecondPaymentTerms(e.target.value);
                                          e.target.value === 'Inbound'
                                            ? setPaymentTerms('OutBound')
                                            : setPaymentTerms('Inbound');
                                        }}
                                      >
                                        <MenuItem value={'OutBound'}>
                                          OutBound
                                        </MenuItem>
                                        <MenuItem value={'Inbound'}>
                                          Inbound
                                        </MenuItem>
                                        <MenuItem value={'Both'}>Both</MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  {value === '3' &&
                                  configuredCarrierName === 'UPS' ? (
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={
                                        secondRatesType === 'Guaranteed' ? 3 : 4
                                      }
                                      lg={
                                        secondRatesType === 'Guaranteed' ? 3 : 4
                                      }
                                      xl={
                                        secondRatesType === 'Guaranteed' ? 3 : 4
                                      }
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel>
                                          Select Service Type{' '}
                                        </InputLabel>
                                        <Select
                                          label='Select Shipment Type  '
                                          fullWidth
                                          size='small'
                                          labelId='demo-simple-select-label'
                                          id='demo-simple-select'
                                          value={secondParcelServiceType}
                                          onChange={e => {
                                            setSecondParcelServiceType(
                                              e.target.value
                                            );
                                          }}
                                        >
                                          <MenuItem value={'All'}>All</MenuItem>
                                          <MenuItem
                                            value={'UPS Next Day Air Early'}
                                          >
                                            UPS Next Day Air Early
                                          </MenuItem>
                                          <MenuItem value={'UPS Next Day Air'}>
                                            UPS Next Day Air
                                          </MenuItem>
                                          <MenuItem value={'UPS Ground'}>
                                            UPS Ground
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  ) : (
                                    configuredCarrierName === 'FedEx' && (
                                      <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={
                                          secondRatesType === 'Guaranteed'
                                            ? 3
                                            : 4
                                        }
                                        lg={
                                          secondRatesType === 'Guaranteed'
                                            ? 3
                                            : 4
                                        }
                                        xl={
                                          secondRatesType === 'Guaranteed'
                                            ? 3
                                            : 4
                                        }
                                      >
                                        <FormControl fullWidth>
                                          <InputLabel>
                                            Select Service Type{' '}
                                          </InputLabel>
                                          <Select
                                            label='Select Shipment Type  '
                                            fullWidth
                                            size='small'
                                            labelId='demo-simple-select-label'
                                            id='demo-simple-select'
                                            value={secondLTLServiceType}
                                            onChange={e => {
                                              setSecondLTLServiceType(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <MenuItem value={'All'}>
                                              All
                                            </MenuItem>
                                            <MenuItem value={'Economy'}>
                                              Economy
                                            </MenuItem>
                                            <MenuItem value={'Priority'}>
                                              Priority
                                            </MenuItem>
                                          </Select>
                                        </FormControl>
                                      </Grid>
                                    )
                                  )}
                                  <Grid
                                    item
                                    xs={rateQuoteUIhandler(
                                      secondRatesType,
                                      'xs'
                                    )}
                                    sm={rateQuoteUIhandler(
                                      secondRatesType,
                                      'sm'
                                    )}
                                    md={rateQuoteUIhandler(
                                      secondRatesType,
                                      'md'
                                    )}
                                    lg={rateQuoteUIhandler(
                                      secondRatesType,
                                      'lg'
                                    )}
                                    xl={rateQuoteUIhandler(
                                      secondRatesType,
                                      'xl'
                                    )}
                                  >
                                    <FormControl fullWidth>
                                      <InputLabel>
                                        Select Rates Type{' '}
                                      </InputLabel>
                                      <Select
                                        label='Select Rates Type  '
                                        fullWidth
                                        size='small'
                                        labelId='demo-simple-select-label'
                                        id='demo-simple-select'
                                        value={secondRatesType}
                                        onChange={e => {
                                          setSecondGuaranteedType('All');
                                          setSecondRatesType(e.target.value);
                                        }}
                                      >
                                        <MenuItem value={'All'}>All</MenuItem>
                                        <MenuItem value={'Standard'}>
                                          Standard
                                        </MenuItem>
                                        <MenuItem value={'Guaranteed'}>
                                          Guaranteed
                                        </MenuItem>
                                      </Select>
                                    </FormControl>
                                  </Grid>
                                  {secondRatesType === 'Guaranteed' && (
                                    <Grid
                                      item
                                      xs={rateQuoteUIhandler(
                                        secondRatesType,
                                        'xs'
                                      )}
                                      sm={rateQuoteUIhandler(
                                        secondRatesType,
                                        'sm'
                                      )}
                                      md={rateQuoteUIhandler(
                                        secondRatesType,
                                        'md'
                                      )}
                                      lg={rateQuoteUIhandler(
                                        secondRatesType,
                                        'lg'
                                      )}
                                      xl={rateQuoteUIhandler(
                                        secondRatesType,
                                        'xl'
                                      )}
                                    >
                                      <FormControl fullWidth>
                                        <InputLabel>
                                          Select Guaranteed Type{' '}
                                        </InputLabel>
                                        <Select
                                          label='Select Guaranteed Type  '
                                          fullWidth
                                          size='small'
                                          labelId='demo-simple-select-label'
                                          id='demo-simple-select'
                                          value={secondGuaranteedType}
                                          onChange={e =>
                                            setSecondGuaranteedType(
                                              e.target.value
                                            )
                                          }
                                        >
                                          <MenuItem value={'All'}>All</MenuItem>
                                          <MenuItem value={'Quickest'}>
                                            Quickest Delivery
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  )}
                                </Grid>
                              )}
                            </TabPanel>
                            <TabPanel value='5'>
                              <Grid sx={{ mt: 0 }} container spacing={0}>
                                <Grid item xs={9}>
                                  <TextField
                                    type='number'
                                    fullWidth
                                    label='Enter Threshold Value'
                                    size='small'
                                    value={thresholdValue}
                                    onChange={e =>
                                      setThresholdValue(e.target.value)
                                    }
                                  />
                                </Grid>
                                <Grid item xs={3}>
                                  <FormControl fullWidth>
                                    <InputLabel>Type </InputLabel>
                                    <Select
                                      label='Type '
                                      fullWidth
                                      size='small'
                                      labelId='demo-simple-select-label'
                                      id='demo-simple-select'
                                      value={thresholdType}
                                      onChange={e =>
                                        setThresholdType(e.target.value)
                                      }
                                    >
                                      <MenuItem value={'$'}>$</MenuItem>
                                      {/* <MenuItem value={'%'}>%</MenuItem> */}
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                            </TabPanel>
                            <TabPanel value={'6'}>
                              <Box p={0}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      fullWidth
                                      size='small'
                                      label='Contact Name'
                                      value={claimSettingsObj.contactName}
                                      onChange={e => {
                                        handleClaimSettingsChange(
                                          'contactName',
                                          e.target.value
                                        );
                                        setErrors(prev => ({
                                          ...prev,
                                          contactName: ''
                                        }));
                                      }}
                                      error={!!errors.contactName}
                                      helperText={errors.contactName}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      fullWidth
                                      size='small'
                                      label='Contact Email'
                                      value={claimSettingsObj.contactEmail}
                                      onChange={e =>
                                        handleClaimSettingsChange(
                                          'contactEmail',
                                          e.target.value
                                        )
                                      }
                                      error={!!errors.contactEmail}
                                      helperText={errors.contactEmail}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      fullWidth
                                      inputProps={{ maxLength: 14 }}
                                      size='small'
                                      label='Contact Phone'
                                      value={formatPhoneNumber(
                                        claimSettingsObj.contactPhone
                                      )}
                                      onChange={e =>
                                        handleClaimSettingsChange(
                                          'contactPhone',
                                          formatPhoneNumber(e.target.value)
                                        )
                                      }
                                      error={!!errors.contactPhone}
                                      helperText={errors.contactPhone}
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      fullWidth
                                      size='small'
                                      label='Copy To (CC)'
                                      value={claimSettingsObj.copyTo}
                                      onChange={e =>
                                        handleClaimSettingsChange(
                                          'copyTo',
                                          e.target.value
                                        )
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Box>
                            </TabPanel>
                          </TabContext>
                        </Grid>
                      </CardContent>
                    )}

                    <CardActions
                      sx={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      {selectedTab.current == 2 && (
                        <Grid
                          sx={{
                            position: 'fixed',
                            top: '11%',
                            left: '34%',
                            zIndex: 1000
                          }}
                        >
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <Button
                              size={isMobile ? 'small' : 'medium'}
                              onClick={() => {
                                setCreateUpdateCarrier(true);
                                selectedTab.current = 2;
                                selectedCarrier.current = {};
                              }}
                              // className='m-2'
                              style={
                                isMobile
                                  ? {
                                      fontSize: 10,
                                      color: '#3361FF',
                                      backgroundColor: '#E4F3FD'
                                    }
                                  : {
                                      color: '#3361FF',
                                      fontSize: 11,
                                      backgroundColor: '#E4F3FD'
                                    }
                              }
                              variant='contained'
                            >
                              Add Carrier
                              <svg
                                className='ms-2'
                                width='11'
                                height='10'
                                viewBox='0 0 11 10'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                                  fill='#3361FF'
                                />
                              </svg>
                            </Button>
                          </div>
                        </Grid>
                      )}
                      <Grid>
                        <Button
                          size='small'
                          variant='outlined'
                          onClick={e => {
                            handleBackToList(e);
                          }}
                        >
                          Back to List
                        </Button>
                      </Grid>

                      {selectedTab.current != '2' && (
                        <Grid
                          sx={{
                            // width: '160px',
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          {/* <Button
                            size='small'
                            variant='outlined'
                            onClick={handleClose}
                          >
                            Cancel
                          </Button> */}
                          <Button
                            disabled={
                              (userPermissionsArr &&
                                userPermissionsArr.filter(
                                  permissions => permissions.level4
                                ).length) ||
                              UserIsAdmin
                                ? false
                                : true
                            }
                            size='small'
                            variant='contained'
                            color='success'
                            onClick={
                              carrierTabValue === '1'
                                ? handleConfirmationCarrierSettins
                                : carrierTabValue === '2'
                                  ? handleThirdPartyRequest
                                  : carrierTabValue === '3'
                                    ? handleSurchargeRequest
                                    : carrierTabValue === '5'
                                      ? handleInvoiceThreshold
                                      : carrierTabValue === '6'
                                        ? handleClaimSettingsRequest
                                        : handleRateQuoteSettingsReq
                            }
                            autoFocus
                          >
                            Confirm
                          </Button>
                        </Grid>
                      )}
                    </CardActions>
                  </Card>
                ) : (
                  // Show kanban view when no carrier is selected
                  <Card
                    sx={{
                      borderRadius: '16px',
                      boxShadow: 3,
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end'
                      }}
                    >
                      <Chip
                        size='small'
                        variant='outlined'
                        label={
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isNewUI}
                                onChange={handleToggle}
                                color='primary'
                                size='small'
                              />
                            }
                            label={isNewUI ? 'New UI' : 'Old UI'}
                            sx={{ ml: 1 }}
                          />
                        }
                        sx={{
                          borderColor: '#1976d2',
                          color: '#1976d2',
                          p: 1,
                          backgroundColor: 'white'
                        }}
                      />
                    </Box>
                    <Typography variant='h6' fontWeight={600} sx={{ mb: 2 }}>
                      Carriers ({carriers.length})
                    </Typography>

                    {/* Kanban View - 3 columns */}
                    <Grid
                      container
                      spacing={2}
                      sx={{ flex: 1, overflow: 'auto' }}
                    >
                      {/* Column 1 */}
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          LTL Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {LTLCarriers.map((items, index) => (
                            <CarrierCard
                              key={index}
                              items={items}
                              selected={false}
                              onSelect={() => {
                                selectedTab.current = 1;
                                handleUpdateCarrier('', items, 'kanbanView');
                                forceUpdate();
                                selectedCarrier.current = items;
                              }}
                              selectedTab={selectedTab.current}
                            />
                          ))}
                        </Box>
                      </Grid>

                      {/* Column 2 */}
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          Parcel Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {parcelCarriers.map((items, index) => (
                            <CarrierCard
                              key={index}
                              items={items}
                              selected={false}
                              onSelect={() => {
                                selectedTab.current = 3;
                                handleUpdateCarrier('', items, 'kanbanView');
                                forceUpdate();
                                selectedCarrier.current = items;
                              }}
                              selectedTab={selectedTab.current}
                            />
                          ))}
                        </Box>
                      </Grid>

                      {/* Column 3 */}
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant='subtitle2'
                          fontWeight={600}
                          sx={{ mb: 1, color: 'primary.main' }}
                        >
                          TL Carriers
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                          }}
                        >
                          {TLcarriers.map((items, index) => (
                            <CarrierCard
                              key={index}
                              items={items}
                              selected={false}
                              onSelect={() => {
                                selectedTab.current = 2;
                                handleUpdateCarrier('', items, 'kanbanView');
                                forceUpdate();
                                selectedCarrier.current = items;
                              }}
                              selectedTab={selectedTab.current}
                            />
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                )}
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid
            xs={12}
            md={12}
            sm={12}
            lg={12}
            xl={12}
            sx={{ backgroundColor: '#fff', p: 0 }}
          >
            <TabContext value={selectedTab.current}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: 'divider',
                  p: 0,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <TabList
                  value={selectedTab.current}
                  onChange={(e, newValue) => handleChange(e, newValue)}
                  aria-label='carrier tabs'
                >
                  {activeCarriers.map(carrier => (
                    <Tab
                      key={carrier.value}
                      label={carrier.permissionName.replace(' Carriers', '')}
                      value={carrier.value}
                    />
                  ))}
                </TabList>
                <Box>
                  <Chip
                    size='small'
                    variant='outlined'
                    label={
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isNewUI}
                            onChange={handleToggle}
                            color='primary'
                            size='small'
                          />
                        }
                        label={isNewUI ? 'New UI' : 'Old UI'}
                        sx={{ ml: 1 }}
                      />
                    }
                    sx={{
                      borderColor: '#1976d2',
                      color: '#1976d2',
                      p: 1,
                      backgroundColor: 'white'
                    }}
                  />
                </Box>
              </Box>
              <TabPanel
                sx={isMobile ? { m: -2 } : {}}
                value={selectedTab.current}
              >
                {userPermissionsArr !== null && (
                  <MaterialReactTable
                    // state={{ isLoading: shipmentsLoader }}
                    columns={columnsData}
                    data={
                      selectedTab.current == 1
                        ? LTLCarriers
                        : selectedTab.current == 2
                          ? TLcarriers
                          : parcelCarriers
                    }
                    enableRowSelection={row => row.original.active}
                    muiTableBodyRowProps={({ row }) => {
                      const isDisabled = !row.original.active && value != '2';

                      return {
                        sx: {
                          backgroundColor: isDisabled
                            ? 'rgba(0, 0, 0, 0.02)'
                            : undefined,
                          '&:hover': {
                            backgroundColor: isDisabled
                              ? 'rgba(0, 0, 0, 0.02) !important'
                              : undefined
                          },
                          opacity: isDisabled ? 0.7 : 1,
                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                          '& td': {
                            color: isDisabled ? 'text.disabled' : 'inherit',
                            '& .MuiIconButton-root': {
                              pointerEvents: isDisabled ? 'none' : 'auto',
                              opacity: isDisabled ? 0.5 : 1
                            }
                          }
                        },
                        title: isDisabled
                          ? 'This carrier is disabled by admin'
                          : undefined
                      };
                    }}
                    enableStickyHeader
                    // muiTableBodyRowProps={({ row }) => ({
                    //   onClick: row.getToggleSelectedHandler()

                    // sx: { cursor: 'pointer' },
                    // })}
                    // enableMultiSort

                    muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
                    // enableStickyHeader
                    // enableStickyFooter

                    muiTableContainerProps={{
                      sx: isMobile
                        ? { maxHeight: '66vh', minHeight: '66vh' }
                        : {
                            maxHeight: '60vh',
                            minHeight: '55vh',
                            overflow: 'auto'
                          }
                    }}
                    positionToolbarAlertBanner='bottom'
                    initialState={{
                      density: 'compact'
                    }}
                    renderToolbarInternalActions={({ table }) => (
                      <div>
                        <MRT_ToggleGlobalFilterButton
                          table={table}
                          title='Search'
                        />

                        <MRT_ToggleFiltersButton
                          table={table}
                          title='Filters'
                        />

                        <MRT_ToggleDensePaddingButton
                          table={table}
                          title='Spacing'
                        />
                        <MRT_ShowHideColumnsButton
                          table={table}
                          title='Show/Hide Columns'
                        />
                        <MRT_FullScreenToggleButton
                          table={table}
                          title='Fullscreen'
                        />
                        <Tooltip title='Clear All Filters' arrow>
                          <IconButton
                            onClick={() => {
                              table.resetColumnFilters(true);
                              table.setShowColumnFilters(false);
                            }}
                          >
                            <FilterAltOffIcon />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                    renderDetailPanel={
                      selectedTab.current !== '1'
                        ? false
                        : ({ row }) => {
                            const eprostatus = carrierProSeriesStatus.filter(
                              cps => cps.carrierId === row.original.carrierId
                            );

                            if (eprostatus.length === 0) {
                              return (
                                <div className='d-flex justify-content-center'>
                                  <Typography className='text-danger'>
                                    Data regarding E-Pro series not found for
                                    this carrier.
                                  </Typography>
                                </div>
                              );
                            }
                            return (
                              <>
                                <Box>
                                  <Row>
                                    <Col lg={12} xl={12} className='px-4'>
                                      <TableContainer
                                        sx={{ width: '100%' }}
                                        component={Paper}
                                      >
                                        <Table
                                          sx={{ width: '100%' }}
                                          // size='small'
                                          // aria-label='a dense table'
                                        >
                                          <TableHead>
                                            <TableRow>
                                              <TableCell
                                                sx={{ fontWeight: 'bold' }}
                                                align='left'
                                              >
                                                Location
                                              </TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>
                                              <TableCell align='left'></TableCell>

                                              <TableCell
                                                sx={{ fontWeight: 'bold' }}
                                                align='left'
                                              >
                                                ProNumber Series
                                              </TableCell>
                                              <TableCell align='left'></TableCell>

                                              <TableCell
                                                sx={{
                                                  fontWeight: 'bold'
                                                }}
                                                align='left'
                                              >
                                                Total ProNumbers
                                              </TableCell>
                                              <TableCell align='left'></TableCell>

                                              <TableCell
                                                sx={{ fontWeight: 'bold' }}
                                                align='left'
                                              >
                                                Consumed ProNumbers
                                              </TableCell>
                                              <TableCell align='left'></TableCell>

                                              <TableCell
                                                sx={{ fontWeight: 'bold' }}
                                                align='left'
                                              >
                                                Remaining ProNumbers
                                              </TableCell>
                                              <TableCell align='left'></TableCell>
                                            </TableRow>
                                          </TableHead>

                                          <TableBody>
                                            {eprostatus.map((prst, index) => (
                                              <TableRow
                                                key={index}
                                                sx={{
                                                  '&:hover': {
                                                    backgroundColor: '#f5f5f5',
                                                    cursor: 'pointer'
                                                  } // Light gray background on hover
                                                }}
                                              >
                                                <TableCell align='left'>
                                                  {prst.locationName}
                                                </TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>
                                                <TableCell align='left'></TableCell>

                                                <TableCell align='center'>
                                                  {prst.proNumberStart &&
                                                  prst.proNumberEnd
                                                    ? `${prst.proNumberStart} - ${prst.proNumberEnd}`
                                                    : '-'}
                                                </TableCell>
                                                <TableCell align='left'></TableCell>

                                                <TableCell align='left'>
                                                  {prst.proNumberTotals}
                                                </TableCell>
                                                <TableCell align='left'></TableCell>

                                                <TableCell align='left'>
                                                  {prst.proNumberTotals &&
                                                    prst.proNumberLeft &&
                                                    calculateConsumed(
                                                      prst.proNumberTotals,
                                                      prst.proNumberLeft
                                                    )}
                                                </TableCell>
                                                <TableCell align='left'></TableCell>

                                                <TableCell align='left'>
                                                  {prst.proNumberLeft}
                                                </TableCell>
                                                <TableCell align='left'></TableCell>
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Col>
                                  </Row>
                                </Box>
                              </>
                            );
                          }
                    }
                    renderTopToolbarCustomActions={({ table }) => {
                      console.log('userPermissionsArr', userPermissionsArr);
                      if (
                        selectedTab.current == '2' &&
                        ((userPermissionsArr &&
                          userPermissionsArr.filter(
                            permissions =>
                              permissions.permissionName === 'TL Carriers' &&
                              permissions.level3
                          ).length) ||
                          UserIsAdmin)
                      ) {
                        return (
                          <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <Button
                              size={isMobile ? 'small' : 'medium'}
                              onClick={() => {
                                setCreateUpdateCarrier(true);
                                history.push('/create-carrier');
                              }}
                              className='m-2'
                              style={
                                isMobile
                                  ? {
                                      fontSize: 10,
                                      color: '#3361FF',
                                      backgroundColor: '#E4F3FD'
                                    }
                                  : {
                                      color: '#3361FF',
                                      backgroundColor: '#E4F3FD'
                                    }
                              }
                              variant='contained'
                            >
                              Add Carrier
                              <svg
                                className='ms-2'
                                width='11'
                                height='10'
                                viewBox='0 0 11 10'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                                  fill='#3361FF'
                                />
                              </svg>
                            </Button>
                          </div>
                        );
                      }
                    }}
                    renderRowActions
                  />
                )}
              </TabPanel>
            </TabContext>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default Carriers;
